var _polygon, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqrms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-226",
    d: "M82.09,256.58c-92.74,53.54-92.74,140.35,0,193.89s243.08,53.54,335.82,0,92.74-140.35,0-193.89S174.83,203,82.09,256.58Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spotlights--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lights--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.92,37l12.6,1.06,3.65,2.77,4.16,14.41,3.1,31.14.19,2L409.1,87l23.56-21.86L445,66.26,448.92,69l4.16,14.41,34,257.79H487l.15,1.14c5.25,39.77-19.8,78.78-68.75,107-44.95,26-104.75,40.25-168.37,40.25S126.59,475.33,81.63,449.37c-48.94-28.26-74-67.27-68.75-107l.14-1.13h0L46.92,83.4,51.08,69,55,66.26l12.33-1.11L89.56,87,91,88.38l.28-2,4.41-31.16,4.16-14.41,3.91-2.73L116.09,37,249.33,156.93l.67.61.67-.61L383.92,37m-.35-1L250,156.19,116.43,36l-13.06,1.18L99,40.23,94.68,55.05,90.26,86.28,67.69,64.11,54.63,65.29l-4.41,3.08L45.94,83.19l-34.06,259h0c-5.11,38.72,18,78.44,69.24,108.05,46.64,26.92,107.76,40.38,168.87,40.38s122.24-13.46,168.87-40.38c51.28-29.61,74.36-69.33,69.24-108h.09l-34.14-259-4.28-14.82-4.41-3.08-13.06-1.18L408.42,86.28l-3.1-31.23L401,40.23l-4.15-3.14L383.57,36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lights--inject-226"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "97.71 27.36 95.52 26.09 95.52 34.7 97.71 35.96 97.71 27.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.71 27.36 95.52 26.09 95.52 34.7 97.71 35.96 97.71 27.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.94 38 104.6 47.55 113.35 52.01 117.46 37.92 106.94 38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.31 49.39 110.68 54.92 110.78 55.6 97.69 58.59 95.9 49.64 102.31 49.39",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.21 48.71 110.68 54.92 97.59 57.91 95.9 49.64 102.21 48.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,32a10.52,10.52,0,0,0-4.75,8.23,3.3,3.3,0,0,0,1.38,3l5.61,3.24a3.31,3.31,0,0,0,3.34-.32A10.51,10.51,0,0,0,101.61,38a3.33,3.33,0,0,0-1.38-3.06l-5.61-3.23A3.31,3.31,0,0,0,91.29,32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.63,33a12.28,12.28,0,0,0-5.56,9.63,3.87,3.87,0,0,0,1.61,3.57L97.25,50a3.86,3.86,0,0,0,3.91-.39A12.28,12.28,0,0,0,106.72,40a3.88,3.88,0,0,0-1.62-3.57l-6.57-3.8A3.89,3.89,0,0,0,94.63,33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,36.76a12.3,12.3,0,0,0-5.56,9.63c0,3.55,2.49,5,5.56,3.21A12.28,12.28,0,0,0,106.72,40C106.72,36.42,104.23,35,101.16,36.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,37.7a10.5,10.5,0,0,0-4.75,8.23c0,3,2.13,4.25,4.75,2.74a10.49,10.49,0,0,0,4.75-8.23C105.91,37.41,103.79,36.18,101.16,37.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.36 39.27 99.57 40.37 95.29 55.19 94.68 55.05 93.68 47.21 95.36 39.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.36 39.27 98.96 40.23 94.68 55.05 93.07 47.07 95.36 39.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.45 36.88 103.47 37.76 116.52 36.59 116.43 35.97 105.7 35.96 99.36 36.26 99.45 36.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.36 36.26 103.37 37.15 116.43 35.97 105.61 35.34 99.36 36.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.94 42.59 86.75 41.32 86.75 31.15 95.52 26.09 97.71 27.36 88.94 32.41 88.94 42.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85,42a2.5,2.5,0,0,1-1.1-2V31.15l8.77-5.06,2.19,1.26-8.77,5.06v8.83C88.94,42,88.45,42.31,87.85,42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.85,41.09A1.35,1.35,0,0,1,87.24,40c0-.38.27-.54.61-.35a1.37,1.37,0,0,1,.6,1C88.45,41.12,88.18,41.28,87.85,41.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.97 55.5 46.77 54.23 46.77 62.84 48.97 64.11 48.97 55.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.97 55.5 46.77 54.23 46.77 62.84 48.97 64.11 48.97 55.5",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.2 66.14 55.86 75.69 64.61 80.15 68.72 66.06 58.2 66.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.57 77.53 61.94 83.06 62.04 83.74 48.95 86.73 47.16 77.78 53.57 77.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.47 76.85 61.94 83.06 48.85 86.05 47.16 77.78 53.47 76.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55,60.14a10.49,10.49,0,0,0-4.75,8.22,3.33,3.33,0,0,0,1.38,3l5.61,3.23a3.29,3.29,0,0,0,3.33-.32,10.48,10.48,0,0,0,4.75-8.22,3.3,3.3,0,0,0-1.38-3l-5.61-3.24A3.29,3.29,0,0,0,42.55,60.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.89,61.13a12.28,12.28,0,0,0-5.57,9.63,3.88,3.88,0,0,0,1.62,3.57l6.57,3.8a3.88,3.88,0,0,0,3.91-.38A12.31,12.31,0,0,0,58,68.11a3.88,3.88,0,0,0-1.62-3.57l-6.57-3.8A3.89,3.89,0,0,0,45.89,61.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.42,64.9a12.3,12.3,0,0,0-5.56,9.63c0,3.55,2.49,5,5.56,3.22A12.31,12.31,0,0,0,58,68.11C58,64.57,55.49,63.13,52.42,64.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.42,65.84a10.5,10.5,0,0,0-4.75,8.23c0,3,2.13,4.25,4.75,2.74a10.52,10.52,0,0,0,4.75-8.23C57.17,65.55,55,64.32,52.42,65.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.62 67.41 50.83 68.51 46.55 83.33 45.94 83.19 44.94 75.35 46.62 67.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.62 67.41 50.22 68.37 45.94 83.19 44.33 75.22 46.62 67.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.71 65.02 54.72 65.91 67.78 64.73 67.69 64.11 56.95 64.1 50.62 64.41 50.71 65.02",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.62 64.41 54.63 65.29 67.69 64.11 56.86 63.48 50.62 64.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.2 70.73 38.01 69.47 38.01 59.29 46.77 54.23 48.97 55.5 40.2 60.56 40.2 70.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.11,70.1a2.5,2.5,0,0,1-1.1-2V59.29l8.76-5.06L49,55.5,40.2,60.56v8.82C40.2,70.13,39.71,70.45,39.11,70.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.11,69.23a1.35,1.35,0,0,1-.61-1c0-.39.27-.55.61-.35a1.34,1.34,0,0,1,.6,1C39.71,69.26,39.44,69.42,39.11,69.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lights--inject-226"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.29 27.36 404.48 26.09 404.48 34.7 402.29 35.96 402.29 27.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.29 27.36 404.48 26.09 404.48 34.7 402.29 35.96 402.29 27.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.06 38 395.4 47.55 386.65 52.01 382.54 37.92 393.06 38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.69 49.39 389.32 54.92 389.22 55.6 402.31 58.59 404.1 49.64 397.69 49.39",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.79 48.71 389.32 54.92 402.41 57.91 404.1 49.64 397.79 48.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.71,32a10.52,10.52,0,0,1,4.75,8.23,3.3,3.3,0,0,1-1.38,3l-5.61,3.24a3.31,3.31,0,0,1-3.34-.32A10.51,10.51,0,0,1,398.39,38a3.33,3.33,0,0,1,1.38-3.06l5.61-3.23A3.31,3.31,0,0,1,408.71,32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.37,33a12.28,12.28,0,0,1,5.56,9.63,3.87,3.87,0,0,1-1.61,3.57L402.75,50a3.86,3.86,0,0,1-3.91-.39A12.28,12.28,0,0,1,393.28,40a3.88,3.88,0,0,1,1.62-3.57l6.57-3.8A3.89,3.89,0,0,1,405.37,33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,36.76a12.3,12.3,0,0,1,5.56,9.63c0,3.55-2.49,5-5.56,3.21A12.28,12.28,0,0,1,393.28,40C393.28,36.42,395.77,35,398.84,36.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,37.7a10.5,10.5,0,0,1,4.75,8.23c0,3-2.13,4.25-4.75,2.74a10.49,10.49,0,0,1-4.75-8.23C394.09,37.41,396.21,36.18,398.84,37.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.64 39.27 400.43 40.37 404.71 55.19 405.32 55.05 406.32 47.21 404.64 39.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.64 39.27 401.04 40.23 405.32 55.05 406.93 47.07 404.64 39.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.55 36.88 396.53 37.76 383.48 36.59 383.57 35.97 394.3 35.96 400.64 36.26 400.55 36.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.64 36.26 396.63 37.15 383.57 35.97 394.39 35.34 400.64 36.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.06 42.59 413.25 41.32 413.25 31.15 404.48 26.09 402.29 27.36 411.06 32.41 411.06 42.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.15,42a2.5,2.5,0,0,0,1.1-2V31.15l-8.77-5.06-2.19,1.26,8.77,5.06v8.83C411.06,42,411.55,42.31,412.15,42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.15,41.09a1.35,1.35,0,0,0,.61-1.06c0-.38-.27-.54-.61-.35a1.37,1.37,0,0,0-.6,1C411.55,41.12,411.82,41.28,412.15,41.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.04 55.5 453.23 54.23 453.23 62.84 451.04 64.11 451.04 55.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.04 55.5 453.23 54.23 453.23 62.84 451.04 64.11 451.04 55.5",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.8 66.14 444.14 75.69 435.39 80.15 431.28 66.06 441.8 66.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.43 77.53 438.06 83.06 437.96 83.74 451.05 86.73 452.84 77.78 446.43 77.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.53 76.85 438.06 83.06 451.15 86.05 452.84 77.78 446.53 76.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.45,60.14a10.49,10.49,0,0,1,4.75,8.22,3.33,3.33,0,0,1-1.38,3l-5.61,3.23a3.29,3.29,0,0,1-3.33-.32,10.48,10.48,0,0,1-4.75-8.22,3.3,3.3,0,0,1,1.38-3l5.61-3.24A3.29,3.29,0,0,1,457.45,60.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.11,61.13a12.28,12.28,0,0,1,5.57,9.63,3.88,3.88,0,0,1-1.62,3.57l-6.57,3.8a3.88,3.88,0,0,1-3.91-.38A12.31,12.31,0,0,1,442,68.11a3.88,3.88,0,0,1,1.62-3.57l6.57-3.8A3.89,3.89,0,0,1,454.11,61.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.58,64.9a12.3,12.3,0,0,1,5.56,9.63c0,3.55-2.49,5-5.56,3.22A12.31,12.31,0,0,1,442,68.11C442,64.57,444.51,63.13,447.58,64.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.58,65.84a10.5,10.5,0,0,1,4.75,8.23c0,3-2.13,4.25-4.75,2.74a10.52,10.52,0,0,1-4.75-8.23C442.83,65.55,445,64.32,447.58,65.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.38 67.41 449.17 68.51 453.45 83.33 454.06 83.19 455.06 75.35 453.38 67.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.38 67.41 449.78 68.37 454.06 83.19 455.67 75.22 453.38 67.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.29 65.02 445.28 65.91 432.22 64.73 432.31 64.11 443.05 64.1 449.38 64.41 449.29 65.02",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.38 64.41 445.37 65.29 432.31 64.11 443.14 63.48 449.38 64.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.8 70.73 461.99 69.47 461.99 59.29 453.23 54.23 451.04 55.5 459.8 60.56 459.8 70.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.89,70.1a2.5,2.5,0,0,0,1.1-2V59.29l-8.76-5.06L451,55.5l8.76,5.06v8.82C459.8,70.13,460.29,70.45,460.89,70.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.89,69.23a1.35,1.35,0,0,0,.61-1c0-.39-.27-.55-.61-.35a1.34,1.34,0,0,0-.6,1C460.29,69.26,460.56,69.42,460.89,69.23Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-226"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-226",
    cx: 77.78,
    cy: 403.2,
    rx: 51.19,
    ry: 29.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-226",
    cx: 167.59,
    cy: 352.74,
    rx: 51.19,
    ry: 29.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-226",
    cx: 269.97,
    cy: 293.35,
    rx: 51.19,
    ry: 29.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-226",
    points: "286.94 345.07 232.62 313.71 288.63 281.37 342.95 312.73 286.94 345.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-226",
    points: "194.32 398.54 140 367.18 196.02 334.84 250.34 366.2 194.32 398.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-226",
    points: "101.73 452.03 47.41 420.67 103.43 388.33 157.75 419.69 101.73 452.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-226",
    cx: 416.11,
    cy: 414.09,
    rx: 59.7,
    ry: 34.47,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-226"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "400.23 407.38 395.95 405.39 397.46 402.37 400.25 404.95 400.23 407.38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.27,399.06s-.11,3.2-.08,4.11-4,3.74-5,4.21l0-2.43a16.36,16.36,0,0,0-2.31,3.45c-.78,1.31-1.77,3.77-3.9,5.44-3.14,2.48-8,3.72-13,3.87s-7.82-1.07-9.22-2.14-1.85-2.31-1.49-3.55S405.27,399.06,405.27,399.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,389.05l0-1.69c-.91,0-1,2.41-2.4,4.55a43.69,43.69,0,0,1-7.07,8.74c-5.08,4.47-9.6,7.28-11.87,9.29-3,2.7,2.23,7.05,10.35,6.66,4-.2,11.21-2.14,13.24-4.46s3.3-6,4.92-7.65,5.1-3.37,6.12-5.43c.56-1.12.29-3.77,0-6-.28-2.07-.32-5.22-1.51-5l-.09,1.06c-.49.9-1.62,2.38-4.88,2.9C397.14,392.29,392.29,392.4,392,389.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,392.09c-1.55-.14-3.21-.65-3.85-2l0,0a3.83,3.83,0,0,1-1.07,3.24c-1.47,1.65-10.73,13.35-10.73,13.35s8.61-9.64,10.26-11.46c2.44-2.68,3.21-3,5.43-3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,395.2a.5.5,0,0,0,.55.43.49.49,0,0,0,.44-.53.5.5,0,0,0-1,.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.68,397.78a.49.49,0,0,0,.55.43.48.48,0,0,0,.44-.53.5.5,0,0,0-1,.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27,400.36a.49.49,0,1,0,1-.1.49.49,0,0,0-1,.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.85,402.94a.5.5,0,1,0,.44-.53A.49.49,0,0,0,386.85,402.94Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.43,405.53a.5.5,0,0,0,.55.43.49.49,0,1,0-.55-.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.61,395.34a.18.18,0,0,0,.13-.06.2.2,0,0,0,0-.27,8.23,8.23,0,0,0-5.6-2.22h0a.2.2,0,1,0,0,.39,7.94,7.94,0,0,1,5.29,2.1A.17.17,0,0,0,394.61,395.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.19,397.91a.21.21,0,0,0,.13-.05.19.19,0,0,0,0-.28,8.25,8.25,0,0,0-5.6-2.22h0a.19.19,0,0,0-.19.2.21.21,0,0,0,.21.19,8,8,0,0,1,5.3,2.1A.17.17,0,0,0,392.19,397.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.77,400.51a.26.26,0,0,0,.13-.06.19.19,0,0,0,0-.28,8.21,8.21,0,0,0-5.6-2.21h0a.2.2,0,0,0-.19.2.21.21,0,0,0,.21.19,8,8,0,0,1,5.3,2.1A.22.22,0,0,0,389.77,400.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,403.09a.18.18,0,0,0,.13-.06.2.2,0,0,0,0-.27,8.23,8.23,0,0,0-5.6-2.22h0a.19.19,0,0,0-.18.2.19.19,0,0,0,.21.19,8,8,0,0,1,5.29,2.1A.25.25,0,0,0,387.36,403.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.94,405.67a.18.18,0,0,0,.13-.06.18.18,0,0,0,0-.27,8.2,8.2,0,0,0-5.6-2.22h0a.2.2,0,0,0-.19.21.19.19,0,0,0,.21.18,8,8,0,0,1,5.3,2.11A.17.17,0,0,0,384.94,405.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.44,422.12c.41,3.85,1.15,6.38,2.65,8.58s4.46,2.66,6.7,2.36a9.4,9.4,0,0,0,7.86-6.57c.9-2.57.63-5.6-.15-9.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.17,393.58c1.11,0,1.68,5.21,2.56,10.37.95,5.52,2.84,8.56,3.58,12.28,1,5.16.78,7.52-.93,10.75s-9.62,6.74-13.08,2.37c-2.83-3.56-3.13-7.63-3.14-12.84a129.64,129.64,0,0,0-.4-13.25c-.4-3.89-.86-7.65.07-8.13.11.57.21,1.29.32,1.85s.29,2.54.91,2.53A8.08,8.08,0,0,0,437,398a1.7,1.7,0,0,1,.24-1.27,2.11,2.11,0,0,1,1.19-.59,32.5,32.5,0,0,1,3.24-.63c.55-.07,1.09-.12,1.64-.14a18.6,18.6,0,0,1,2.89,0,1,1,0,0,1,.62.5,1.53,1.53,0,0,1,.08.6,4.71,4.71,0,0,0,.19,1.06c.05.15.17.34.32.29s.17-.19.17-.32c0-.63-.13-1.08-.2-1.81,0-.34-.11-.8-.13-1.14S447.21,393.92,447.17,393.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.35,417.69a.38.38,0,0,1-.33.43.38.38,0,0,1-.43-.32.38.38,0,0,1,.32-.43A.39.39,0,0,1,449.35,417.69Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.81,414.12a.38.38,0,0,1-.33.42.39.39,0,0,1-.44-.32.38.38,0,0,1,.33-.42A.39.39,0,0,1,448.81,414.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.29,410.74a.38.38,0,0,1-.32.43.39.39,0,0,1-.44-.32.38.38,0,0,1,.33-.43A.38.38,0,0,1,448.29,410.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.79,407.41a.38.38,0,0,1-.32.43.39.39,0,0,1-.44-.32.38.38,0,0,1,.32-.43A.39.39,0,0,1,447.79,407.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.12,408.32a.38.38,0,0,1-.32.43.39.39,0,0,1-.44-.32.38.38,0,0,1,.33-.43A.38.38,0,0,1,439.12,408.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.63,411.67a.38.38,0,0,1-.32.43.39.39,0,0,1-.44-.32.38.38,0,0,1,.32-.43A.39.39,0,0,1,439.63,411.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.14,415.05a.39.39,0,0,1-.32.43.39.39,0,0,1-.44-.32.38.38,0,0,1,.33-.43A.38.38,0,0,1,440.14,415.05Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.69,418.63a.38.38,0,0,1-.33.42.39.39,0,0,1-.44-.31.38.38,0,0,1,.33-.43A.39.39,0,0,1,440.69,418.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444 420.18 439.83 395.23 441.25 395.14 444 420.18",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,417.94h-.06c-2.56-.45-6.88,0-8.53.88a.19.19,0,0,1-.27-.07.19.19,0,0,1,.08-.26c1.75-.94,6.11-1.39,8.79-.93a.19.19,0,0,1,0,.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.45,414.36h-.1c-2-.82-6.6-.12-8.5.9a.2.2,0,0,1-.26-.08.19.19,0,0,1,.08-.26c2-1.06,6.74-1.78,8.83-.92a.2.2,0,0,1,.11.25A.2.2,0,0,1,448.45,414.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.94,411a.17.17,0,0,1-.1,0c-2-.81-6.61-.11-8.5.9a.19.19,0,0,1-.26-.08.18.18,0,0,1,.07-.26c2-1,6.75-1.77,8.84-.91a.19.19,0,0,1,.1.25A.16.16,0,0,1,447.94,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.44,407.65a.14.14,0,0,1-.11,0c-2-.81-6.6-.11-8.49.9a.2.2,0,0,1-.27-.08.18.18,0,0,1,.08-.25c2-1.06,6.75-1.78,8.83-.92a.19.19,0,0,1,.11.25A.19.19,0,0,1,447.44,407.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.85,266.67c3.75,30.93,4.94,74.33,4.94,74.33.22,2.4,1.51,13.16,2.66,25,1.21,12.52,2.16,36,2.16,36s-8.94,4.69-16.17,2.31c0,0-9-37.17-12.65-51.93-3.47-14-7.54-42.76-7.54-42.76l-3.81,26.17s.47,9,.18,15.35c-.34,7.34-5.22,42.64-5.22,42.64s-9.73,5.59-17.22-.06c0,0-2.68-46.54-2.76-55.38-.16-17.78,1.55-50.4,2.26-72.78Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.62,303.1q1,11.38,2.19,22.76c.39,3.79.81,7.57,1.23,11.36l.65,5.68.33,2.84c.1.95.3,1.88.44,2.82,1.25,7.52,3.17,21.17,4.54,28.67s2.83,15,4.39,22.45q-1.49-11.34-3.25-22.62c-1.18-7.53-3-21.19-4.3-28.69-.15-.94-.35-1.88-.46-2.82l-.35-2.84-.71-5.66q-.72-5.67-1.48-11.33Q429.34,314.41,427.62,303.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M393.54,300.91c-.83,7.08-1.28,14.2-1.61,21.32s-.63,14.25-.38,21.37.31,19,.56,26.17.56,14.23,1,21.34q.21-10.68.13-21.36c0-7.11-.12-19-.25-26.16l-.12-5.34,0-1.33,0-1.32,0-2.67.16-10.67.21-10.67C393.29,308,393.42,304.47,393.54,300.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M414.25,309.61l-3.1-17.36S402.39,291,397.9,287c0,0,2.89,5.24,11.15,7.3l3.09,15.33-1.7,26.13Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.55,203c-4.18,1.08-8.5,2.85-14.5,8.91-7.17,7.23-15.4,15.27-15.4,15.27l-29-1.08,1.23,11.73s14.69,3.81,24.65,5.33c6.3,1,7.67,1.64,13.94-2.93,7.42-5.4,15.34-11.38,15.34-11.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.16,254.45l-3.52-21.61a5.09,5.09,0,0,0-2.54-3.38l-28.28-13.4c-1.19-.56-2,0-1.76,1.34.95,5.87,2.56,15.76,3.52,21.62a5,5,0,0,0,2.53,3.38l28.28,13.4C369.58,256.36,370.37,255.76,370.16,254.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,227a2.86,2.86,0,0,1,.6-.49,2.23,2.23,0,0,1,.74-.31,2.93,2.93,0,0,1,.9,0,4.52,4.52,0,0,1,1.12.29,5.76,5.76,0,0,1,1.55.93,6.88,6.88,0,0,1,1.31,1.38,8.73,8.73,0,0,1,1,1.75,9,9,0,0,1,.55,2,5.88,5.88,0,0,1,.05,1.7,3.67,3.67,0,0,1-.33,1.1,2.37,2.37,0,0,1-.55.68l-.6.49a3.48,3.48,0,0,0-.47.47.94.94,0,0,0-.17.66l.07,1.89-1.61-.64-.49-2.26a2.33,2.33,0,0,1,0-1.07,1.66,1.66,0,0,1,.37-.68,3.54,3.54,0,0,1,.58-.5,3.25,3.25,0,0,0,.59-.53,2,2,0,0,0,.41-.76,2.68,2.68,0,0,0,0-1.22,3.59,3.59,0,0,0-.26-.92,3.67,3.67,0,0,0-.45-.8,3.78,3.78,0,0,0-.61-.65,2.94,2.94,0,0,0-.72-.42,2.12,2.12,0,0,0-.89-.19,1.56,1.56,0,0,0-.58.12,2.29,2.29,0,0,0-.39.21.36.36,0,0,1-.3,0,1.05,1.05,0,0,1-.55-.61Zm3.94,15.15a2.71,2.71,0,0,1,0-.75,1.23,1.23,0,0,1,.21-.53.68.68,0,0,1,.39-.25.91.91,0,0,1,.55.06,1.89,1.89,0,0,1,.59.39,3.88,3.88,0,0,1,.52.61,4.32,4.32,0,0,1,.41.77,4,4,0,0,1,.23.85,2.35,2.35,0,0,1,0,.75,1.13,1.13,0,0,1-.21.52.71.71,0,0,1-.4.25,1,1,0,0,1-.54-.07,2,2,0,0,1-.59-.38,2.8,2.8,0,0,1-.52-.61,3.65,3.65,0,0,1-.4-.76A3.56,3.56,0,0,1,350.59,242.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.9,216.31a1.29,1.29,0,0,1,.73.16l28.28,13.4a4.67,4.67,0,0,1,2.28,3l3.52,21.62a1.22,1.22,0,0,1-.1.85.42.42,0,0,1-.29.17,1.27,1.27,0,0,1-.73-.16L340.3,242a4.7,4.7,0,0,1-2.28-3l-1.75-10.81-1.77-10.81a1.16,1.16,0,0,1,.11-.85.4.4,0,0,1,.29-.17m-.07-.45c-.59.09-.92.65-.77,1.54.95,5.87,2.56,15.76,3.52,21.62a5,5,0,0,0,2.53,3.38l28.28,13.4a1.75,1.75,0,0,0,1,.2c.6-.09.92-.65.78-1.55l-3.52-21.61a5.09,5.09,0,0,0-2.54-3.38l-28.28-13.4a1.74,1.74,0,0,0-1-.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.59,228.1c-.94-1.66-.82-1.85-.15-2.58a4.8,4.8,0,0,1,4.12-1.61,9.68,9.68,0,0,1,3.36.73c.66.43-.08,1.84-1.87,2.05-2.82.34-2.88,1.1-2.88,1.1a34.19,34.19,0,0,1,3.63-.26,26.68,26.68,0,0,1,4,1c1.15.31,1.23,1.85-.8,2.17l2.1.56c1.47.4,1.9,1.26.63,2.07a2.18,2.18,0,0,1-1.4.37s1.59.16,1.57.7c-.06,1.54-1.09,1.84-4.4,2.44-3.15.58-4,2.18-3.46,3.39,0,0-1.16-.85-2.18-1.73-.75-.65-1.37-1.35-.88-2.58,0,0-1.75-.15-1.75-1.26a5.67,5.67,0,0,1,.66-2.3,2,2,0,0,1-.79-1.91,3.21,3.21,0,0,1,.83-1.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,230.74a9.76,9.76,0,0,0-1.92-.42,6.31,6.31,0,0,0-1.93.4,22.59,22.59,0,0,0-3.57,1.48,23.5,23.5,0,0,0,3.74-.93,9.75,9.75,0,0,1,1.78-.5C341.67,230.73,342.34,230.79,343,230.74Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,233.74a4.26,4.26,0,0,0-2.09-.29,11.58,11.58,0,0,0-2.06.43,19.89,19.89,0,0,0-3.85,1.59,41.36,41.36,0,0,0,4-1A10.89,10.89,0,0,1,344.31,233.74Z",
    style: {
      fill: "#9a4a4d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.8,206.86s4.61,4.51,2.84,16.15c-1.53,10.12-2.4,18.64-2.69,22.58-.44,6,.2,26.37.2,26.37-9.11,10.87-48.25,8-52.88-1.95,0,0,.09-14.47.68-28,.43-9.9.63-19.3,2.11-25.08,2-7.75,5.42-11.49,8.34-13.68l12.87-3,11.68-.07Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.65,176.5a17.85,17.85,0,0,0-.5-5.4,15.57,15.57,0,0,0-1.95-4.51c-2.27-3.51-6.77-5.34-10.74-6.24a18.08,18.08,0,0,0-12.59,1.34c-2.66,1.46-5.48,4.35-6.3,7.26a21.82,21.82,0,0,0-.77,5c0,2.26.68,3.19.29,5a27.58,27.58,0,0,0-.09,11.75c1,4.17,2.2,6,6.13,7a21.88,21.88,0,0,0,4.49.35l.32,3.86c-1.89,7.42.35,11.18.35,11.18,7.1-8.92,13.27-6.69,15.52-11.83l.06-6.66c.07-1.63.11-4.2.11-4.2a4.43,4.43,0,0,0,3.64-.36,6.88,6.88,0,0,0,3.18-4.67c.33-1.57.7-4.72-1.52-6.2A18.59,18.59,0,0,0,432.65,176.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.15,171.1a15.57,15.57,0,0,0-1.95-4.51c-2.27-3.51-6.77-5.34-10.74-6.24a18.08,18.08,0,0,0-12.59,1.34A15,15,0,0,0,405,163a2.33,2.33,0,0,1,.81,1.23,7,7,0,0,0,.37,1.85c1.05,1.89,5.27.14,6.75-.34,1.85-.61,3.87-1.14,5.71-.51a4.94,4.94,0,0,1,3.25,4.41,7.94,7.94,0,0,1-.49,2.68,3.62,3.62,0,0,0-.28,2.16c.38,1.26,2,1.67,2.66,2.83.43.82-.06,4.07,1.16,4.16.56,0,.85-.63,1.1-1.13a3.42,3.42,0,0,1,.65-.86,5,5,0,0,1,5.62-.35c.06-.27.1-.53.14-.8h0a15.09,15.09,0,0,0,.22-1.79A17.85,17.85,0,0,0,432.15,171.1Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,190.32a3.11,3.11,0,0,1-1.46-1.6,3.37,3.37,0,0,0,1.43,2.81Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.76 176 403.53 183.35 408.69 185.09 409.76 176",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55,174.57l4-.93a2,2,0,0,0-2.38-1.59A2.19,2.19,0,0,0,401.55,174.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,175.57l-3.74-1.69a2,2,0,0,1,2.64-1.09A2.17,2.17,0,0,1,417,175.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.62,198c4.71-.41,8.06-1.09,11.11-3.86a14.79,14.79,0,0,0,3.11-4.71s-.48,4-2.62,6c-1.85,1.67-4.08,3.9-11.47,4.3Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,177.94a1.37,1.37,0,0,0,1.12,1.57,1.39,1.39,0,1,0-1.12-1.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.22,186.65,407.94,188a2.87,2.87,0,0,0,3.43,2A2.7,2.7,0,0,0,413.22,186.65Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.37,190.05a2.63,2.63,0,0,0,1.87-1.9,3.23,3.23,0,0,0-3.6,1.77A2.76,2.76,0,0,0,411.37,190.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,176.08a1.39,1.39,0,1,0,1.24,1.46,1.36,1.36,0,0,0-1.24-1.46",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tie--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.29,213a16.52,16.52,0,0,0,2.58-2.18c1.15-1.24,1.69-1.81,2.14-1.38a30.22,30.22,0,0,1,2.94,5.16c.5,1.14.4,1.14,2,.1a27.66,27.66,0,0,0,7.06-6.82,20.94,20.94,0,0,0,2.82-5.63s-1.75-2.48-2.27-3.42c-1-1.83-.64-2.93-1.67-2.78v1.47c-.33,1.15-2.75,3.18-5,5.08s-5.77,3.72-6.61,4.54C414.65,207.74,411.29,213,411.29,213Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.08,199.68a68.43,68.43,0,0,0-5.91,17.21c-2.16,10.17-2,30.93-2.56,44.43s-.26,23.08-.26,23.08c5.57,1.39,16.83.74,22.61-4.4,0,0-.92-16.91-2.5-37.84.72-19.79,1.14-36.61,1.14-36.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.9,224.87l-6.79,3.79-.32.17c.68,2,1.39,3.95,2.1,5.92-1.89,6.63-3.71,13.29-5.22,20-.48,2.26-1,4.53-1.25,6.84.44-2.28,1-4.52,1.63-6.75,1.14-4.27,4.44-15.64,5.71-20l0-.13c-.64-1.83-1.27-3.66-1.93-5.48l6.61-3.78.19-.11-2-22.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,211.84c.25.65,2.31-4.41,3.31-4.3.49,0,1.38,2.55,1.87,3.49s.79,1.39,1.12,2c-.6-1.52-.75-5.46-.87-6.48a18.32,18.32,0,0,1,.52-4.7l-.32-3.86c-.28,0-.57,0-.89,0a16.46,16.46,0,0,0-1.43,1.73c-1,1.62-2.8,4.55-3.13,6.49A17.22,17.22,0,0,0,405,211.84Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.78,200.53s-8.52,16.95-9.39,28.84-1.73,52-1.73,52-7.39-1.64-10.54-6.9c0,0,.89-22,1.65-37.73.87-18.14,3.69-28.67,10.78-33.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,222.75l.16-.24-.15-.24-3.54-5.45c3-4.07,7.58-10.28,10.43-14.29-3.2,3.87-8.07,10.06-11.21,14l-.16.21.14.23,3.48,5.48-3.56,4.95c-.11.15-.11.11-.09.3.9,9.85,1.84,20.1,3.05,29.89-.49-9.81-1.33-20-2.14-29.8Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.38,230.17c-2.53-2.16-3.82-3-5-3.44s-5.44-2.51-7.08-3c-1-.33-1.56,1.33-.29,2.58a36.57,36.57,0,0,0,4.74,3A21.28,21.28,0,0,1,410,233Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,244.73c-2.41-.51-15.17-3.26-16.73-4.4-1.72-1.27-6.22-6.79-7.74-8.45-2.07-2.26-3.17-2-4.3-1.94-3.69.33-4.51.07-5.31.52s-.8,1.92-.8,1.92c-1,.06-2.43-.06-2.71,1.54a4.66,4.66,0,0,0-.14,1.29,1,1,0,0,0-.65.32c-.86.9.32,4.25,1.16,5.11a3.15,3.15,0,0,0,2.62.63c1-.08.6-1.11.6-1.11l1.37.16c2.85,2.31,2.74,6.55,6.62,7.72a27.53,27.53,0,0,1,4.74,1.23c5.85,2.39,14.22,7.84,21.27,11.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.11,232.38l4.39-.62h-4.33C406.14,232,406.12,232.18,406.11,232.38Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.26,235.21l5-.35-5-.24A2.81,2.81,0,0,0,403.26,235.21Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.44,239.45a2,2,0,0,1-.56-1s-1.11-.09-1.67-.21a6.13,6.13,0,0,1-.72-.25,1.86,1.86,0,0,1-.7-.51,1.55,1.55,0,0,0,.64.63,3.14,3.14,0,0,0,.73.31l.25.65a1,1,0,0,0-.53.16,1.35,1.35,0,0,0-.48.63,1.58,1.58,0,0,1,.54-.52,1,1,0,0,1,.68-.08,2.17,2.17,0,0,1,1.37.91l1.37.16A10.42,10.42,0,0,1,407.44,239.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6,205.55c5.27,2.09,8.17,3.89,9.68,7,2.61,5.31,3.15,12.66,4,21.39s1.47,19.34,1.19,24.2-3.09,6-5,6.5-5.36.14-9.39-1.51-18-10.74-18-10.74,1.76-1.48,2.35-5.6-.37-6-.37-6l11.57,2.3s-1.09-11-1.4-17.76S436.86,208.54,441.6,205.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.42,241.36l.16,1.72c5.24.69,9.29,4.64,10.07,6.78C447.14,246.51,445.16,242.88,437.42,241.36Z",
    style: {
      opacity: 0.2
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.89,280.54c-.74-10.12,2.78-23.81,1.71-39.52-.88-13-2.91-17.41-3.1-19.91,0,0-1.57-23.31-1.28-52.36.13-13.36-4.38-18.24-7.48-25.33l-38.87-.21c-3.3,18.61-7.41,52.4-6.37,73.24.57,11.44,4.43,55.65,4.42,56.78,0,4.28.12,5.14-1.45,6.83-3.29,3.54-7.91,6.27-12,9.35.59,1.58,6.16,2.21,8.62,1a63.15,63.15,0,0,0,9.16-5.84c3.39-2.51,7.72-4.53,7.78-8.35a5.25,5.25,0,0,1,.11-.68c.07-2.23,5.43-31.37,5.87-39,.37-6.56-.43-17.7-.43-17.7l4.23-27.8s3.31,20.91,6,32.13c2.15,9.13,5,20.24,7.42,31.48h0c2.41,12.18,4.48,20.72,5.33,25.45-.14,2.62,2.1,18.13,2.83,21.6s8.3,3.58,8.79-2.41C302.42,295.31,301,282.45,300.89,280.54Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.78,191l-3.09-20s-12-1.43-16.32-5.61c0,0,5.49,7.75,13.61,9L269.39,191l-1.8,27.59Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,293.45c.4.68.05,3,1.18,4,1.31,1.15,5.15,3.05,10.26,2.45s7.89-2.16,10-3.85,4.95-4.06,7.27-4.55a13.92,13.92,0,0,0,5.18-2.05c.69-.66,0-4.29,0-4.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22,274.47s.39,0,.51.7.29,3.18.62,4.51a24,24,0,0,1,.42,7.17c-.3,1.51-3.8,2.52-6,3.35a28,28,0,0,0-7.28,4.49,21.05,21.05,0,0,1-10.82,3.89c-5.08,0-8.35-1.39-9.35-3.23-1.23-2.27-.83-4.25,5-6.89,1.11-.5,5-2.76,6.35-3.58a29.4,29.4,0,0,0,4-2.91,22.78,22.78,0,0,0,1.8-1.74,8.17,8.17,0,0,0,1.5-1.88c.07-.15.12-.33.18-.49a9.18,9.18,0,0,0,.39-1.36c.1-.49.17-1.19.63-1.48a4.06,4.06,0,0,1,1.74-.16,12,12,0,0,1,2.23.17,5,5,0,0,1,3.32,1.9,4.28,4.28,0,0,1,.46,2.12c0,.34,0,.68,0,1,0,.15-.07.41.14.35s.42-.56.49-.73c.17-.38.27-.79.46-1.16a5.66,5.66,0,0,1,.74-1.23,5.12,5.12,0,0,1,.93-.93,11.52,11.52,0,0,0,1-.64A2.37,2.37,0,0,0,262.22,274.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36,288.89c7.34.59,10.21,5.84,10.5,8.65a17.1,17.1,0,0,1-5.24,1c-5.08,0-8.56-1.39-9.55-3.23C228.9,293.21,229.12,290.81,234.36,288.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,289.77a.34.34,0,0,0,.23-.08.35.35,0,0,0,0-.5c-1-1.27-4.54-3.64-7.22-3.38a.36.36,0,1,0,.07.71c2.5-.23,5.79,2.11,6.59,3.12A.35.35,0,0,0,246,289.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.17,288a.3.3,0,0,0,.22-.08.35.35,0,0,0,.06-.5c-1-1.27-4.55-3.65-7.22-3.38a.35.35,0,0,0-.32.39.34.34,0,0,0,.39.32c2.49-.24,5.79,2.11,6.59,3.12A.37.37,0,0,0,249.17,288Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,285.89a.4.4,0,0,0,.23-.08.36.36,0,0,0,.06-.51c-1-1.26-4.56-3.64-7.23-3.38a.36.36,0,0,0,.07.72c2.5-.24,5.8,2.11,6.6,3.11A.38.38,0,0,0,252.12,285.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,283.81a.3.3,0,0,0,.22-.08.35.35,0,0,0,.07-.5c-1.39-1.79-5.17-3.69-7.84-3.42a.36.36,0,1,0,.07.71,10,10,0,0,1,7.2,3.15A.35.35,0,0,0,255,283.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,304.42c.2,3.46.74,5.76,2,7.8a5.12,5.12,0,0,0,5.91,2.07c2.35-.59,5.36-2.18,6-5.18a18.73,18.73,0,0,0,.53-8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.81,279.3c1,.08,1.25,4.74,1.81,9.4.6,5,2.09,7.06,2.62,11.16.61,4.68-.16,6.77-1.8,9.6S296,315.07,293.13,311c-2.33-3.31-2.43-7-2.21-11.65a103.11,103.11,0,0,0-.32-11.84c-.18-3.51-1-7-.12-7.43.07.51.13,1.17.2,1.67a7.86,7.86,0,0,0,.31,1.87c.1.26.31.53.4.11a2.82,2.82,0,0,0,0-.87c-.14-1.29.51-1.4.86-1.5a44.84,44.84,0,0,1,4.49-.63c.74-.05,3.3-.17,3.63.26a2.8,2.8,0,0,1,.33,1.35c.08.7.24,1.22.26,1,.05-.51,0-1.82-.06-2.13s-.06-.72-.07-1S300.83,279.6,300.81,279.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.51,302.57a11.66,11.66,0,0,1-1.81,7.11c-1.64,2.84-7.91,5.62-10.77,1.57a13.29,13.29,0,0,1-2-6.84C292.64,301.29,302.81,299.91,305.51,302.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,299.32l.12,0a16.45,16.45,0,0,1,8.88-.86.36.36,0,0,0,.43-.27.36.36,0,0,0-.27-.43,16.84,16.84,0,0,0-9.35.91.36.36,0,0,0-.17.48A.34.34,0,0,0,293,299.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.82,294.94a.35.35,0,0,0,.31-.24.37.37,0,0,0-.23-.46c-4.34-1.47-9.16.74-9.34.83a.36.36,0,0,0,.33.64s4.74-2.16,8.78-.79A.39.39,0,0,0,301.82,294.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.67,291.65a.35.35,0,0,0,.3-.24.36.36,0,0,0-.21-.46,12.7,12.7,0,0,0-9.52.81.36.36,0,0,0,.37.61s4.46-2.33,8.9-.74A.31.31,0,0,0,301.67,291.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.43,288.41a.36.36,0,0,0,.3-.23.35.35,0,0,0-.21-.46c-4.47-1.68-9.4.8-9.58.9a.36.36,0,0,0-.13.49.34.34,0,0,0,.49.13s4.81-2.41,9-.85A.3.3,0,0,0,301.43,288.41Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.9,108.51h0a13.33,13.33,0,0,1-13.33-13.33v-30h2.21A11.11,11.11,0,0,1,295.9,76.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.33,69.34a8.17,8.17,0,0,1,.36,1.7,5.15,5.15,0,0,1,0,1.11,3.77,3.77,0,0,1-3.66,3,5.73,5.73,0,0,1-4.4-2.36c-1.42-1.82-3.55-6.11-.78-7.64a5.64,5.64,0,0,1,5.88.49A7.24,7.24,0,0,1,289.33,69.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.33,69.34a8.17,8.17,0,0,1,.36,1.7,5.15,5.15,0,0,1,0,1.11,3.77,3.77,0,0,1-3.66,3,5.73,5.73,0,0,1-4.4-2.36c-1.42-1.82-3.55-6.11-.78-7.64a5.64,5.64,0,0,1,5.88.49A7.24,7.24,0,0,1,289.33,69.34Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.54,169.9a11.41,11.41,0,0,0-.82,2.9c-.26,2.46.87,4.82,1.58,7.19a2.22,2.22,0,0,1-.2,2.23.52.52,0,0,1-.45.25.6.6,0,0,1-.37-.28,14.29,14.29,0,0,1-1.71-3,15.37,15.37,0,0,0,.38,3.1,5.37,5.37,0,0,1,.24,2.47c-.19.81-1.07,1.52-1.84,1.19a2.15,2.15,0,0,1-1-1.26c-.25-.6-.5-1.2-.76-1.8a22.79,22.79,0,0,1-1-2.54,11.84,11.84,0,0,1,1.27-9.4,4.7,4.7,0,0,1,1.8-1.82,2.89,2.89,0,0,1,2.34-.07C247.56,169.27,247.73,169.42,247.54,169.9Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.66,174.84a84.9,84.9,0,0,1,.19-9.74c.36-3.1,1.07-14.66,1.39-18,.42-4.36.69-7,1.12-9.72.48-3,1.16-5.31,2.65-11.79,1.7-7.34,2-8.77,3.33-12.49.84-2.42,3.44-8.28,12.65-9.56,1.51,8.67-.94,23.14-.94,23.14s-4.23,7.61-5.53,10.92c-.68,1.72-2,7.11-3.71,14.1-1,4-1.93,8.94-1.93,8.94-.39,2.48.2,3.08.88,5a45.54,45.54,0,0,1,1.93,7.31c.31,1.73.48,3,.62,4.27.11,1-.65,1.44-1.68.42-1.22-1.22-1.21-2.4-1.79-3.66-.73-1.56-2-4.21-2.7-3.56s-1.23,2.93-2.06,4.36a6.54,6.54,0,0,0-.83,4.81c.34,2,1.61,4.7,1.42,6.48s-1.18,2.23-1.61,1.54-1.92-4.79-2.41-6.21A19.48,19.48,0,0,1,239.66,174.84Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.74,162.31c-2.42-11-7.41-21-7.63-22.57-.65-4.66,3.46-11.72,4.07-15.82,1.34-8.93-2.93-17.91-5-19.67l-4.74-1.11a37.07,37.07,0,0,0-4.45-.8,53.69,53.69,0,0,0-11.93-.33c-1,.1-5.55.89-5.55.89-1.39.32-2.5.66-2.51.67A38.89,38.89,0,0,0,250.63,113c-2.87,3.64-8.08,13.62.06,22.06.18,2.47-.25,5.23-.12,10.65-4.35,21.31-7,48.69-7,54.46,11.37,9.6,45.31,8.59,58.15.57C300.18,187.77,300.29,169.36,298.74,162.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.5,84l-1.09-.34c-4.9-2.62-4.65-9-3.46-12.34,2.65-7.43,10.68-10.21,15.65-10.48,9.42-.51,14,1.92,15,6.8,1.28-.11,3,.92,4.09,2.36,2.32,3.15,5.07,14.14-7.14,25.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,92a4.34,4.34,0,0,0,4-1.82c2.18-2.6,2.29-5.16,1.16-6.82-.93-1.36-3.12-2.17-4.59-1.17s-1.59,1.91-2.16,3.07-2.93,1.16-3.67-3.43c-.7-4.28-1.5-8.2-3.69-10.06-3.25-2.77-6.73-2.16-7.92-.4-1.36-2-3.35-2.69-5.45-1.46s-3.61,4.51-4,12.7c-.43,8.35,1.72,13.46,3.69,14.79,1.48,1,3.13,1.42,6.25,1.44l-.11,3.67s-5.1,11.32-4.81,18.46c0,0,2.6-4.53,10.36-11.31l8.43-7.37.44-11.52A2.66,2.66,0,0,0,282.81,92Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.94,78.07l3.19-.77a1.57,1.57,0,0,0-1.92-1.24A1.73,1.73,0,0,0,257.94,78.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.19,78.14l3.28,1.26a1.68,1.68,0,0,0-1-2.26A1.84,1.84,0,0,0,269.19,78.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.44,72.45a13.37,13.37,0,0,1,1,4.54c.15,1.39.28,4.66,1.22,6.6a5.06,5.06,0,0,0,3.88,3,6.68,6.68,0,0,0,3.26-.33c.65-.3,2.45-1.57,2.23-3.44a3.69,3.69,0,0,1-2.52,1.22,3.65,3.65,0,0,1-3.09-1.71c-1.21-1.8-1.13-4.23-1.5-6.3-.48-2.63-.93-5.62-3.31-6.92-2.8-1.54-7.07-.62-7.68,2.24A4.34,4.34,0,0,1,272.44,72.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.91,89.68,265.32,91a2.39,2.39,0,0,0,3.15,1.59A2.25,2.25,0,0,0,269.91,89.68Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.16,92.62a2.5,2.5,0,0,1,2.6-2.12.93.93,0,0,1,.23,0,2.12,2.12,0,0,1-1.52,2A2.81,2.81,0,0,1,267.16,92.62Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.14 79.81 265.17 87.98 260.74 86.26 266.14 79.81",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41,98.85a29,29,0,0,0,8.82-2c1-.44,2.39-2.33,3.5-4.42,0,0-.75,4.11-3,5.54-3.35,2.18-9.41,2.7-9.41,2.7Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,81.26c-.24.67.22.89.87,1.12s1.22.38,1.46-.29a1.24,1.24,0,1,0-2.33-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06,80.72a3.37,3.37,0,0,0-.93-.35,2.81,2.81,0,0,0-1-.06,3,3,0,0,0-1,.28s0,.08,0,.08a8.15,8.15,0,0,1,.87-.08,4.3,4.3,0,0,1,1.07.14,4.68,4.68,0,0,1,1.22.47l.39.22s.07-.07.05-.1A2,2,0,0,0,261.06,80.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,81.91c.15.69-.34.85-1,1s-1.26.21-1.41-.49a1.24,1.24,0,1,1,2.42-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,81.07a3.52,3.52,0,0,1,1-.22,2.82,2.82,0,0,1,1,.07,3.12,3.12,0,0,1,.93.41s0,.09,0,.08a7,7,0,0,0-.86-.2,5.15,5.15,0,0,0-2.35.3l-.42.16s-.05-.08,0-.1A2.12,2.12,0,0,1,269.28,81.07Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Podium--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 339.19 287.01 329.93 333.24 303.24 333.24 312.5 287.01 339.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 339.19 287.01 329.93 333.24 303.24 333.24 312.5 287.01 339.19",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 329.93 246.76 306.69 246.76 315.95 287.01 339.19 287.01 329.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 329.93 246.76 306.69 246.76 315.95 287.01 339.19 287.01 329.93",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 329.93 246.76 306.69 293 280 333.24 303.24 287.01 329.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 329.93 246.76 306.69 293 280 333.24 303.24 287.01 329.93",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 326.12 326.63 303.24 331.1 183.93 287.01 209.38 287.01 326.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 326.12 326.63 303.24 331.1 183.93 287.01 209.38 287.01 326.12",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 326.12 253.37 306.69 248.9 187.38 287.01 209.38 287.01 326.12",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.01 326.12 253.37 306.69 248.9 187.38 287.01 209.38 287.01 326.12",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.58 197.89 331.1 183.93 287.01 209.38 248.9 187.38 249.42 201.34 287.01 223.05 330.58 197.89",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.91 218.68 283.91 205.89 345.83 170.14 345.83 182.93 283.91 218.68",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.91 218.68 283.91 205.89 345.83 170.14 345.83 182.93 283.91 218.68",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.91 205.89 240.57 180.87 240.57 193.66 283.91 218.68 283.91 205.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.91 205.89 240.57 180.87 240.57 193.66 283.91 218.68 283.91 205.89",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.91 205.89 240.57 180.87 302.49 145.12 345.83 170.14 283.91 205.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.91 205.89 240.57 180.87 302.49 145.12 345.83 170.14 283.91 205.89",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.8,180.24c0-1.26-.83-2.52-2.49-3.47a13.28,13.28,0,0,0-12,0c-1.66.95-2.49,2.21-2.49,3.47v1.66c0,1.26.83,2.52,2.49,3.47a13.28,13.28,0,0,0,12,0c1.66-1,2.49-2.21,2.49-3.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,176.77c-1.66.95-2.49,2.21-2.49,3.47s.83,2.51,2.49,3.47a13.34,13.34,0,0,0,12,0c1.66-1,2.49-2.22,2.49-3.47s-.83-2.52-2.49-3.47A13.28,13.28,0,0,0,255.28,176.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-226",
    d: "M268.73,179.82a3.69,3.69,0,0,1-2.18,3,11.61,11.61,0,0,1-10.52,0,3.71,3.71,0,0,1-2.18-3,7.44,7.44,0,1,1,14.88,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,175.31a4.39,4.39,0,0,1,.14,2,6,6,0,0,1-3.3,4.19,11.35,11.35,0,0,1-5.37,1.05,9.21,9.21,0,0,1-2.71-.39,7.59,7.59,0,0,1-1.62-.79,5,5,0,0,0,1.69,1.52,11.61,11.61,0,0,0,10.52,0,3.69,3.69,0,0,0,2.18-3A7.37,7.37,0,0,0,267.2,175.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.21,173.92a5.09,5.09,0,0,0-2.71,3.25,2.57,2.57,0,0,0,.09,1.6,1.79,1.79,0,0,0,.63.65,3.44,3.44,0,0,0,3.45-.26c1-.62,1.87-1.53,2.86-2.23a8.93,8.93,0,0,1,2.06-1.06,1.92,1.92,0,0,0,.87-.46.7.7,0,0,0-.15-.95C263.35,172.83,260.17,173,258.21,173.92Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microphone--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.35,169a1.49,1.49,0,0,0-.87-1.22,4.7,4.7,0,0,0-4.23,0,1.49,1.49,0,0,0-.87,1.22v1.12a1.49,1.49,0,0,0,.87,1.22,4.7,4.7,0,0,0,4.23,0,1.49,1.49,0,0,0,.87-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.25,167.8a1.29,1.29,0,0,0,0,2.44,4.64,4.64,0,0,0,4.23,0,1.29,1.29,0,0,0,0-2.44A4.7,4.7,0,0,0,327.25,167.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.16,166.29a.9.9,0,0,0-.52-.74,2.86,2.86,0,0,0-2.55,0,.9.9,0,0,0-.52.74V169a.89.89,0,0,0,.52.73,2.86,2.86,0,0,0,2.55,0,.89.89,0,0,0,.52-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,165.55a.9.9,0,0,0-.52.74.89.89,0,0,0,.52.73,2.8,2.8,0,0,0,2.55,0,.89.89,0,0,0,.52-.73.9.9,0,0,0-.52-.74A2.86,2.86,0,0,0,328.09,165.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,166.1c0,.25-.81.25-.81,0,0-.42,0-.91,0-1.47.09-7.94.32-29-12.71-36l.38-.72c13.47,7.22,13.23,28.68,13.14,36.76C329.78,165.19,329.77,165.68,329.77,166.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.84,131l-4.13-2a2.76,2.76,0,0,1-1.27-3.7h0a2.76,2.76,0,0,1,3.7-1.27l4.12,2a2.76,2.76,0,0,1,1.28,3.7h0A2.77,2.77,0,0,1,314.84,131Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.65,208.69a1.3,1.3,0,0,0-1.36.09l-28.77,16.61a4.92,4.92,0,0,0-2,3.92V249a1.83,1.83,0,0,0,.68,1.64l1.06.61a1.33,1.33,0,0,0,1.32-.12l28.76-16.6a4.92,4.92,0,0,0,2.06-3.93V210.91a1.86,1.86,0,0,0-.66-1.62C325.5,209.17,324.8,208.79,324.65,208.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.65,208.69a1.3,1.3,0,0,0-1.36.09l-28.77,16.61a4.92,4.92,0,0,0-2,3.92V249a1.83,1.83,0,0,0,.68,1.64l1.06.61a1.33,1.33,0,0,0,1.32-.12l28.76-16.6a4.92,4.92,0,0,0,2.06-3.93V210.91a1.86,1.86,0,0,0-.66-1.62C325.5,209.17,324.8,208.79,324.65,208.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,234.52l-28.76,16.6c-1.13.66-2,0-2-1.55V229.89a5,5,0,0,1,2-3.93l28.76-16.6c1.14-.66,2.06,0,2.06,1.55v19.68A4.92,4.92,0,0,1,324.29,234.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.32,248.07c-.28.17-.51,0-.51-.39v-18.6a1.26,1.26,0,0,1,.51-1l27.18-15.69c.28-.16.51,0,.51.39v18.6a1.23,1.23,0,0,1-.51,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.45,228.88l4.17-2.4a.63.63,0,0,1,.77,0l.5.38a1,1,0,0,1,.31.85V232a2.66,2.66,0,0,1-.31,1.22l-.5,1a2,2,0,0,1-.77.86l-2.74,1.58a1.29,1.29,0,0,0-.63,1.2v2.93c0,.55.21.71.63.47l3.69-2.13c.42-.25.63-.09.63.47v.23a1.27,1.27,0,0,1-.63,1.2l-4.18,2.41a1,1,0,0,1-.41.15.7.7,0,0,1-.36-.1l-.45-.26a1,1,0,0,1-.35-.85V238a2.35,2.35,0,0,1,.08-.6,3.35,3.35,0,0,1,.25-.62l.49-.92a2,2,0,0,1,.77-.86l2.75-1.6a1.27,1.27,0,0,0,.63-1.19v-3.07q0-.84-.63-.48l-3.71,2.15q-.63.36-.63-.48v-.23A1.29,1.29,0,0,1,299.45,228.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.36,223.74l3.22-1.86a.63.63,0,0,1,.76,0l.51.38a1,1,0,0,1,.31.84v10.82a2.35,2.35,0,0,1-.08.6,3,3,0,0,1-.25.61l-.5,1a2,2,0,0,1-.77.84l-3.21,1.86a.68.68,0,0,1-.77,0l-.5-.38a1,1,0,0,1-.31-.84V226.77a2.55,2.55,0,0,1,.31-1.2l.5-1A2.09,2.09,0,0,1,308.36,223.74Zm3.37,10.4v-9.61c0-.56-.21-.71-.62-.47l-2.29,1.32a1.27,1.27,0,0,0-.63,1.19v9.61c0,.54.21.7.63.45l2.29-1.32A1.26,1.26,0,0,0,311.73,234.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32,219.14l3.21-1.85a.61.61,0,0,1,.77,0l.5.37a1,1,0,0,1,.32.85v10.82a2.27,2.27,0,0,1-.08.59,3.1,3.1,0,0,1-.25.62l-.5,1a2.18,2.18,0,0,1-.77.84l-3.21,1.85a.69.69,0,0,1-.77.05l-.5-.38a1,1,0,0,1-.31-.84V222.18A2.56,2.56,0,0,1,315,221l.5-1A2.09,2.09,0,0,1,316.32,219.14Zm3.37,10.4v-9.6q0-.84-.63-.48l-2.28,1.32a1.27,1.27,0,0,0-.63,1.2v9.61q0,.81.63.45l2.28-1.32A1.25,1.25,0,0,0,319.69,229.54Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.17,140l-5.95-14s-4.42-11.7-.05-21.73c8.43,1.18,10.18,4.35,11.8,7.74a89.75,89.75,0,0,1,5.58,14.41c3,9.37,3.72,11.61,4.27,15.39.67,4.69-2.49,6.94-8.5,10s-9.95,4.62-18.67,8.19c-4.19,1.72-6.72,2-10.52,2.89a14.39,14.39,0,0,1-4.37.43,8.42,8.42,0,0,1-3.84-1.11,2.44,2.44,0,0,0-.65-.36,5.69,5.69,0,0,0-.72-.12,4.83,4.83,0,0,1-1.36-.27,8.14,8.14,0,0,1-1.22-.82,3.63,3.63,0,0,0-.55-.39,4,4,0,0,0-.65-.26,5.38,5.38,0,0,1-1.7-.69,1,1,0,0,1-.37-.85s-.79-.11-1.05-.17a5,5,0,0,1-1.08-.34c-.14-.06-.29-.14-.33-.28a.57.57,0,0,1,0-.26c.39-1.35,1.78-1.68,3-1.87,3.17-.5,5.26-.15,8.38-1,1.7-.46,2.11-.6,2.53-1.06.45-.85-3.66-1.8-5.08-3.78-.7-1-.49-2.79,1-2.08,3.17,1.49,5.05,1.27,7.17,2a12.41,12.41,0,0,0,7.11.18C283.88,149,296.17,140,296.17,140Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.17,140a36.32,36.32,0,0,1,6.21-4.26s-2.33-.27-6.65,3.11Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.84,158.53c.79.14,1.59.21,2.39.28s1.59.11,2.39.17c.39,0,.79.07,1.2.08s.8,0,1.2,0c.81,0,1.61-.11,2.4-.22H266c-.4,0-.8,0-1.19,0s-.79-.07-1.19-.1c-.8-.05-1.6-.08-2.4-.1Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.33,160.18a9.49,9.49,0,0,0,1.8.52c.61.11,1.22.19,1.84.25s1.22.11,1.84.12a14.24,14.24,0,0,0,1.85,0l-1.83-.18-1.83-.18-1.83-.19C262.56,160.4,261.94,160.3,261.33,160.18Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217,166.7a32.72,32.72,0,0,0,1.42-4.59c.68-4,1.82-5.07,4.37-8.18.43-.53.87-1.05,1.32-1.58a7.86,7.86,0,0,0,.62-.78c.17-.26.32-.48.7-.37a1.17,1.17,0,0,1,.62.54,3.36,3.36,0,0,1,.17,2.71A16.19,16.19,0,0,1,225,157c-.32.63.48.5.85.38,1.82-.58,3.79-2.88,5-4.29a25.59,25.59,0,0,1,2.39-2.8,3.88,3.88,0,0,1,2.05-.95c.52,0,1,.09,1,.74a2.5,2.5,0,0,1-.41,1.12,2.83,2.83,0,0,0-.44,2.25,6.47,6.47,0,0,1,.48,1.59c0,.7-.34,1.37-.38,2.07.36.16.52.78.24,1.5a17.71,17.71,0,0,1-2.88,5.15,17.39,17.39,0,0,1-4.71,4c-1,.65-2.77,1.48-3.36,2.6s-2.35,5.84-4.09,10.72c-3.08,8.56-3.93,11.7-7.11,14.36-2.23,1.86-5.76,1.4-12-2.45-10.33-6.35-20.26-13-20.26-13V162.88c6.53,1.47,7,2.66,12.56,7.06,7.23,5.68,13.72,11.06,13.6,11.16S216.5,167.77,217,166.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.53,181.1c-2.53,3.25-2.1,8.56-2.1,8.56a11.47,11.47,0,0,1,.94-9.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,159.35a7.26,7.26,0,0,1-2,6.35,4.85,4.85,0,0,0,2.41-2.56A4.48,4.48,0,0,0,224.93,159.35Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.17,338.46c.74-10.18-.4-10.07.44-26h0c.08-4.08.23-8.44.5-12.32.92-13.05,2.93-17.51,3.12-20,0,0,.34-20.3,1.19-48.85.41-13.44,4.3-17.5,7.41-24.63h37c4.13,17.59,2.73,56,2.61,74.08-.06,9.25-3.09,50-3.16,51.17-.27,4,.09,5.63,1.67,7.32,3.31,3.56,8.11,6.94,12.26,10-.6,1.58-6.3,2.28-8.77,1.08a62.89,62.89,0,0,1-9.21-5.88c-3.41-2.52-7.77-4.55-7.83-8.39a5.65,5.65,0,0,0-.11-.69c-.07-2.24-5.3-27.41-5.73-35.08-.38-6.6.43-17.8.43-17.8l-1.68-28S166.42,271,164,282.36c-1.81,8.4-6.32,25.47-8.74,34.65-1.72,6.53-5.19,15.89-5.78,22.4-.18,1.56-1.95,16.83-2.67,20.33s-8.36,3.59-8.85-2.42C137.63,353.31,139,340.38,139.17,338.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.27,254.55l3.11-20.17s12-1.42,16.41-5.63c0,0-5.52,7.79-13.68,9.06l-3.43,16.72-.77,27.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,354.08a3.3,3.3,0,0,1-.58,3.33c-1.31,1.15-5.17,3.07-10.31,2.46s-7.94-2.17-10-3.87-5-4.09-7.3-4.57a14.09,14.09,0,0,1-5.21-2.07c-.7-.66-.64-3.62-.64-3.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,334.31s-.39,0-.51.7-.3,3.2-.62,4.54a24,24,0,0,0-.43,7.21c.3,1.51,3.83,2.53,6.08,3.36a28.42,28.42,0,0,1,7.33,4.52,21.26,21.26,0,0,0,10.87,3.92c5.11,0,8.4-1.4,9.4-3.25,1.24-2.28,1-4.35-4.95-7-1.11-.5-5-2.77-6.38-3.59a30.47,30.47,0,0,1-4-2.93,25.06,25.06,0,0,1-1.81-1.76,8,8,0,0,1-1.5-1.88c-.07-.15-.12-.33-.18-.49a8.37,8.37,0,0,1-.4-1.38c-.1-.48-.16-1.19-.63-1.48a3.94,3.94,0,0,0-2.1-.23,26.23,26.23,0,0,0-3.17.66,2.94,2.94,0,0,0-2.16,1.55,4.34,4.34,0,0,0-.47,2.13c0,.35,0,.69,0,1,0,.15.06.41-.15.35s-.41-.56-.49-.73c-.17-.39-.28-.8-.46-1.17a6.45,6.45,0,0,0-.74-1.24,5.91,5.91,0,0,0-.94-.93,10.2,10.2,0,0,1-1-.64A2.34,2.34,0,0,1,176.14,334.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,348.75c-7.39.58-10.37,5.93-10.66,8.76a17.56,17.56,0,0,0,5.26,1.05c5.11,0,8.61-1.4,9.61-3.25C209.64,353.16,209.53,350.68,204.26,348.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,349.7a.4.4,0,0,1-.23-.08.37.37,0,0,1-.06-.51c1-1.27,4.68-3.73,7.37-3.46a.36.36,0,0,1,.33.39.36.36,0,0,1-.4.32c-2.51-.23-5.93,2.19-6.73,3.2A.35.35,0,0,1,192.47,349.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.27,347.88a.38.38,0,0,1-.23-.08.36.36,0,0,1-.06-.51c1-1.27,4.68-3.73,7.37-3.46a.35.35,0,0,1,.32.39.35.35,0,0,1-.39.32c-2.51-.24-5.93,2.19-6.74,3.2A.35.35,0,0,1,189.27,347.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,345.79a.4.4,0,0,1-.23-.08.36.36,0,0,1-.05-.51c1-1.27,4.69-3.73,7.36-3.46a.36.36,0,0,1,.33.39.37.37,0,0,1-.39.33c-2.51-.24-5.93,2.19-6.74,3.19A.35.35,0,0,1,186.29,345.79Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,343.7a.34.34,0,0,1-.22-.07.37.37,0,0,1-.07-.51c1.4-1.8,5.3-3.77,8-3.51a.36.36,0,1,1-.07.72c-2.42-.24-6.1,1.63-7.34,3.23A.35.35,0,0,1,183.38,343.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.19,362.47c-.2,3.49-.74,5.8-2,7.84a5.13,5.13,0,0,1-5.94,2.09c-2.36-.6-5.39-2.2-6.07-5.21a19.08,19.08,0,0,1-.53-8.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.25,337.22c-1,.08-1.26,4.76-1.82,9.45-.6,5-2.1,7.1-2.64,11.22-.61,4.71.16,6.81,1.81,9.65s7.49,5.64,10.37,1.57c2.35-3.33,2.44-7,2.23-11.71a104.6,104.6,0,0,1,.31-11.91c.19-3.53,1-7.08.13-7.47-.07.52-.13,1.17-.2,1.68a8.5,8.5,0,0,1-.32,1.88c-.1.26-.31.54-.4.11a2.89,2.89,0,0,1,0-.88c.14-1.29-.51-1.4-.87-1.5a42.18,42.18,0,0,0-4.51-.64c-.75-.05-3.32-.16-3.65.26a2.88,2.88,0,0,0-.33,1.36c-.08.71-.24,1.23-.26,1,0-.51.05-1.83.06-2.15s.06-.72.07-1S139.23,337.52,139.25,337.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,360.62a11.73,11.73,0,0,0,1.82,7.15c1.65,2.84,8,5.65,10.84,1.57a13.42,13.42,0,0,0,2-6.87C147.47,359.33,137.24,357.94,134.52,360.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06,357.35l-.12,0a16.45,16.45,0,0,0-8.93-.87.36.36,0,0,1-.16-.71,17,17,0,0,1,9.41.92.36.36,0,0,1-.2.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,352.94a.35.35,0,0,1-.31-.24.37.37,0,0,1,.23-.46c4.37-1.48,9.21.74,9.39.84a.36.36,0,0,1,.16.48.38.38,0,0,1-.49.16s-4.77-2.18-8.83-.8A.26.26,0,0,1,138.23,352.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,349.63a.36.36,0,0,1-.3-.23.37.37,0,0,1,.22-.47,12.78,12.78,0,0,1,9.57.81.36.36,0,0,1-.37.62s-4.49-2.35-9-.75A.29.29,0,0,1,138.38,349.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.62,346.38a.37.37,0,0,1-.3-.24.35.35,0,0,1,.21-.46c4.5-1.69,9.45.8,9.64.91a.36.36,0,0,1,.13.49.34.34,0,0,1-.49.13s-4.85-2.42-9-.86A.34.34,0,0,1,138.62,346.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.25,206.66c-4.38,8-6.74,14.51-7.18,38.26s.32,30.51.23,33.38-2.7,9.19-3,23.37c-.25,12-.3,21.12-.3,21.12s1.36,2.86,6.75,3.35c5,.44,7.44-1.43,7.44-1.43s6-19.81,7.8-28.33c2-9.85,7.81-33.26,7.81-33.26l1.69,19.35a77.37,77.37,0,0,0-.32,18.25,139.79,139.79,0,0,0,3.4,19.45,28.24,28.24,0,0,0,8.2,1.25,17.06,17.06,0,0,0,7.47-1.91s3.47-28.74,3.47-42.75,1.54-49.76-1.64-70.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,233.27l-4.91,29.85,1.69,19.35.65-22.54,4-22.12c3.38-.81,11.07-4.87,13.19-10.66C183.08,232.6,173.71,233.27,173.71,233.27Zm-15.8-15.76c.6-2.26,1.23-4.52,1.94-6.78a33.48,33.48,0,0,0-3,6.43,65.24,65.24,0,0,0-2,6.83c-.53,2.31-1,4.64-1.28,7a46.58,46.58,0,0,0-.47,7.09c.57-2.31,1.09-4.6,1.62-6.89s1-4.57,1.59-6.85S157.33,219.78,157.91,217.51Zm-3.4-1.7c.77-1.38,1.53-2.77,2.24-4.22a25.36,25.36,0,0,0-3.21,3.59,34.48,34.48,0,0,0-2.61,4,30.61,30.61,0,0,0-2,4.41,19,19,0,0,0-1.08,4.71L150,224.1c.73-1.39,1.46-2.78,2.22-4.15S153.76,217.2,154.51,215.81ZM152,299.68q-1.78,9.93-3.32,19.9,2.31-9.82,4.35-19.7c1.39-6.58,2.69-13.15,4-19.78s2-13.33,2.68-20,1.14-13.4,1.55-20.12c-.93,6.67-1.76,13.34-2.6,20s-1.73,13.32-3,19.91S153.18,293.06,152,299.68Zm36.27-33.27c.14,3.22.34,6.45.28,9.63s-.26,6.43-.42,9.65l-.49,9.67q-.5,9.67-.77,19.37,1.14-9.63,1.93-19.29c.53-6.45,1-12.87,1.25-19.38,0-6.53-.58-12.95-1.16-19.4s-1.37-12.86-2.37-19.25l1.22,19.34C187.92,260,188.13,263.19,188.28,266.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-226",
    d: "M144.61,217.72c1.62-7.4,3-13.07,3-14.7-.07-7.1-4.15-16.42-4.77-20.54-1.34-9,3.46-16.76,5.54-18.53,0,0,3.23-.63,7.8-1.65,1.56-.35,3-.53,5.33-.86a29.54,29.54,0,0,1,9.73.2c1,.1,4.72.27,4.72.27,1.39.33,5.38,1,5.38,1a39.08,39.08,0,0,1,5.48,7.85c2.27,4.06,3.57,7.46,4,16.17.51,11.09,1.71,23.53,1.71,31.27C183.35,223.82,156.46,224.63,144.61,217.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hair--inject-226",
    d: "M153.68,128.43c-.74-6.2,10.7-14.16,22.77-7.69s8.66,14.13,8.09,16.42a23.87,23.87,0,0,0-.86,5.88,8.31,8.31,0,0,0,1.56,5.08,3.62,3.62,0,0,0,4.45,1c-.27,2.8-1.89,5-6.11,6.82a11.29,11.29,0,0,1-5.5.59c.64.43,1.57,1.11,4.33,1-1.72,2.17-8.19,4.4-14.17.67a1.58,1.58,0,0,0-.94-.12,3.19,3.19,0,0,0-1.09.43c-2.69,1.35-6.19,1.1-9.05.57a12.67,12.67,0,0,1-4.55-1.67,6.7,6.7,0,0,1-2.9-3.78,6.19,6.19,0,0,0,.62,4.22,8.1,8.1,0,0,1-2.93-1.4,6.4,6.4,0,0,1-1.89-5.44,21.27,21.27,0,0,1,1.65-5.74,14.24,14.24,0,0,0,1.25-6.38,22.66,22.66,0,0,1,0-4.51C148.77,131.3,150.43,128.82,153.68,128.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72,159.64c-.07-1.46-.72-8.81-.72-8.81,0,.55-2.61,2.2-5.16-.49s-2.89-5.71-1.57-7.71c1.46-2.21,5-2.3,6.59,1.09,1.06,1.19,2.82-.37,1.8-3.71.08-2.37,3.34-5.15,1.28-9.06,6.49-4.87,14.21-5,18.53-1.71a39.85,39.85,0,0,1,2.4,12.9c.18,7.83-1.7,11.72-4.12,13.18-1.63,1-3.13,1.27-6.07,1.2L172,159h0c.13,1.22.07,2.14,1.29,2.47.82.22,2.74.47,2.74.47s3.07,4.64-4.57,5.53c-12.17,1.42-16-5-16-5l1.43-.4C158.55,161.58,158.79,161.11,158.72,159.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.68,156.52c-5.28-.22-10.4-1.65-11.72-4a4.72,4.72,0,0,0,2.33,3.74c3.09,1.58,9.6,2.09,9.6,2.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,134.07l-3.26-.61a1.6,1.6,0,0,1,1.88-1.35A1.74,1.74,0,0,1,179,134.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9,134.85l3.08-1.33a1.6,1.6,0,0,0-2.15-.92A1.77,1.77,0,0,0,164.9,134.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,138.52a1.41,1.41,0,0,0,1.36,1.43,1.34,1.34,0,0,0,1.41-1.3,1.42,1.42,0,0,0-1.36-1.43A1.32,1.32,0,0,0,176,138.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,139.35a1.42,1.42,0,0,0,1.36,1.43,1.34,1.34,0,0,0,1.41-1.31,1.44,1.44,0,0,0-1.36-1.43A1.33,1.33,0,0,0,166,139.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42,136.13l-8,5a3.45,3.45,0,0,1,2.62.41l5.79-3.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,134.43a18.37,18.37,0,0,0-6.6.58c-1.89.73-2.55,1.44-3.61,1.52s-1.88-.54-3.94-1a20.66,20.66,0,0,0-6.6.34c-.72,0-1.36.3-1.33,1.25s.71,1,.89,1.71c.45,2.47,1.25,5.55,4.51,5.51,6.73,0,4.26-6.39,6.74-6.2.9.15.85,1.88,1.46,3.07a4.92,4.92,0,0,0,.9,1.29c2.3,2.19,6.39.68,6.92-1.66.5-1.17.31-3,.84-4C183.76,136.34,184.12,134.63,183.08,134.43Zm-12.49,5.81a4.06,4.06,0,0,1-.85,1.9,3.68,3.68,0,0,1-2.72,1.24,3.18,3.18,0,0,1-3.38-1.91c0-.13-.11-.25-.15-.38-.34-1-.83-3.22-.31-3.89,1-1.12,5.78-1.3,7.27.25A4.16,4.16,0,0,1,170.59,140.24ZM182,139.06a4.15,4.15,0,0,1-1.75,3.09c-1.79,1-4.39.21-4.86-1.55-1.29-3.68.12-4.62,3.83-5.19C182.3,135.24,182.51,136,182,139.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,143.64,173,146l-1.1-6.68a1.82,1.82,0,0,1,.46-.88Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.72,148.47,168.89,147a2.41,2.41,0,0,0,1.61,3.12A2.64,2.64,0,0,0,173.72,148.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,148a2.4,2.4,0,0,0,1.73,2.2,2.56,2.56,0,0,0,1.73-.11A4.15,4.15,0,0,0,168.77,148Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132,227.68c.11,3.6-.52,6.73-.36,8.53a37.81,37.81,0,0,0,.45,4.21,10.37,10.37,0,0,0,1.34,3,21.15,21.15,0,0,0,1.37,3.58,18.61,18.61,0,0,0,2.63,3.16c.61,1.74.59,1.91.86,2.66a1.34,1.34,0,0,0,.38.69.62.62,0,0,0,.64-.05,1.6,1.6,0,0,0,.65-1.07,7.35,7.35,0,0,0-.34-3.27,28.25,28.25,0,0,1-.72-4.48,2.89,2.89,0,0,0,.29.79c.16.4.23.82.38,1.23l2.14,5.85a1,1,0,0,0,.3.48.61.61,0,0,0,.64,0,1.19,1.19,0,0,0,.44-.5,4.05,4.05,0,0,0,.17-2.49,29.82,29.82,0,0,0-.7-3.25,23,23,0,0,1-.73-3.49,18.38,18.38,0,0,1-.2-3.47c0-.49,0-2.6,1-1.73a1.88,1.88,0,0,1,.45.79,7.43,7.43,0,0,0,1.31,2.35,3.19,3.19,0,0,0,2.36,1.14.78.78,0,0,0,.4-.08.73.73,0,0,0,.3-.77,3,3,0,0,0-.36-.8,1.14,1.14,0,0,1-.1-.19c-1.29-2.51-1.38-5.2-2.52-7.44-.35-.7-1-2.18-1.4-3.21a10.1,10.1,0,0,1-1.18-3.83c-.13-1.95,1.71-22.43,1.71-22.43l5.66-15.18c4.55-11.47,1.26-21.12-.88-24.51-6.53,1.43-9,4.24-10.51,8.06-1,2.48-1.5,4.74-3,11.3-1.7,7.27-2.19,10-3.36,15.91-.63,3.18-.74,4.68-.38,12.07C131.45,217.73,131.92,224.07,132,227.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,250.2a28.4,28.4,0,0,1-1.79-5.34,18.52,18.52,0,0,1-.32-4.14c.16,1.38.32,2.74.59,4.09S137,248.88,137.46,250.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.46,243.46a7.38,7.38,0,0,1-.57-2,9.57,9.57,0,0,1-.08-2.07c.16.67.24,1.35.36,2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.93,244.68a18.47,18.47,0,0,1-.86-3.49,7.54,7.54,0,0,0,1,4.69Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 392.66 194.39 383.4 240.62 356.72 240.62 365.97 194.39 392.66",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 392.66 194.39 383.4 240.62 356.72 240.62 365.97 194.39 392.66",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 383.4 154.15 360.17 154.15 369.43 194.39 392.66 194.39 383.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 383.4 154.15 360.17 154.15 369.43 194.39 392.66 194.39 383.4",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 383.4 154.15 360.17 200.38 333.47 240.62 356.72 194.39 383.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 383.4 154.15 360.17 200.38 333.47 240.62 356.72 194.39 383.4",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 379.59 234.02 356.72 238.48 237.4 194.39 262.86 194.39 379.59",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 379.59 234.02 356.72 238.48 237.4 194.39 262.86 194.39 379.59",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 379.59 160.75 360.17 156.28 240.85 194.39 262.86 194.39 379.59",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 379.59 160.75 360.17 156.28 240.85 194.39 262.86 194.39 379.59",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.96 251.37 238.48 237.4 194.39 262.86 156.28 240.85 156.8 254.82 194.39 276.52 237.96 251.37",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 272.15 191.3 259.36 253.22 223.61 253.22 236.4 191.3 272.15",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 272.15 191.3 259.36 253.22 223.61 253.22 236.4 191.3 272.15",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 259.36 147.95 234.34 147.95 247.13 191.3 272.15 191.3 259.36",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 259.36 147.95 234.34 147.95 247.13 191.3 272.15 191.3 259.36",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 259.36 147.95 234.34 209.87 198.59 253.22 223.61 191.3 259.36",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.3 259.36 147.95 234.34 209.87 198.59 253.22 223.61 191.3 259.36",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.18,233.71c0-1.26-.83-2.51-2.49-3.47a13.26,13.26,0,0,0-12,0c-1.66,1-2.49,2.21-2.49,3.47v1.67c0,1.25.83,2.51,2.49,3.47a13.32,13.32,0,0,0,12,0c1.66-1,2.49-2.22,2.49-3.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,230.24c-1.66,1-2.49,2.21-2.49,3.47s.83,2.51,2.49,3.47a13.26,13.26,0,0,0,12,0c1.66-1,2.49-2.21,2.49-3.47s-.83-2.51-2.49-3.47A13.26,13.26,0,0,0,162.67,230.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-226",
    d: "M176.12,233.3a3.69,3.69,0,0,1-2.18,3,11.61,11.61,0,0,1-10.52,0,3.67,3.67,0,0,1-2.18-3,7.44,7.44,0,0,1,14.88,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,228.78a4.39,4.39,0,0,1,.14,2,6,6,0,0,1-3.3,4.19,11.29,11.29,0,0,1-5.36,1.05,9.1,9.1,0,0,1-2.71-.38,8.22,8.22,0,0,1-1.63-.8,4.82,4.82,0,0,0,1.7,1.52,11.61,11.61,0,0,0,10.52,0,3.69,3.69,0,0,0,2.18-3A7.41,7.41,0,0,0,174.58,228.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,227.39a5.16,5.16,0,0,0-2.71,3.26,2.51,2.51,0,0,0,.1,1.6,1.76,1.76,0,0,0,.63.64,3.39,3.39,0,0,0,3.44-.26c1-.62,1.88-1.53,2.87-2.23a8.66,8.66,0,0,1,2.05-1.06,1.92,1.92,0,0,0,.87-.46.71.71,0,0,0-.15-.95C170.74,226.31,167.55,226.42,165.59,227.39Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microphone--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.74,222.5a1.48,1.48,0,0,0-.88-1.22,4.62,4.62,0,0,0-4.22,0,1.46,1.46,0,0,0-.88,1.22v1.11a1.48,1.48,0,0,0,.88,1.22,4.62,4.62,0,0,0,4.22,0,1.5,1.5,0,0,0,.88-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64,221.28a1.46,1.46,0,0,0-.88,1.22,1.48,1.48,0,0,0,.88,1.22,4.68,4.68,0,0,0,4.22,0,1.5,1.5,0,0,0,.88-1.22,1.48,1.48,0,0,0-.88-1.22A4.62,4.62,0,0,0,234.64,221.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.55,219.76A.9.9,0,0,0,238,219a2.78,2.78,0,0,0-2.54,0,.9.9,0,0,0-.53.73v2.75a.9.9,0,0,0,.53.73,2.78,2.78,0,0,0,2.54,0,.9.9,0,0,0,.53-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.48,219a.9.9,0,0,0-.53.73.89.89,0,0,0,.53.73,2.78,2.78,0,0,0,2.54,0,.89.89,0,0,0,.53-.73A.9.9,0,0,0,238,219,2.78,2.78,0,0,0,235.48,219Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.16,219.57c0,.26-.82.26-.82,0,0-.42,0-.91,0-1.47.09-7.94.33-29-12.71-36l.39-.71c13.46,7.22,13.23,28.67,13.14,36.75C237.16,218.66,237.16,219.15,237.16,219.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.22,184.43l-4.12-2a2.76,2.76,0,0,1-1.28-3.7h0a2.76,2.76,0,0,1,3.7-1.28l4.13,2a2.77,2.77,0,0,1,1.27,3.7h0A2.77,2.77,0,0,1,222.22,184.43Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232,262.17a1.28,1.28,0,0,0-1.36.08l-28.76,16.61a4.9,4.9,0,0,0-2.06,3.92v19.69a1.84,1.84,0,0,0,.68,1.63c.18.12.89.51,1.07.61a1.29,1.29,0,0,0,1.31-.11L231.68,288a4.93,4.93,0,0,0,2-3.92V264.38a1.84,1.84,0,0,0-.66-1.62C232.89,262.64,232.19,262.26,232,262.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,262.17a1.28,1.28,0,0,0-1.36.08l-28.76,16.61a4.9,4.9,0,0,0-2.06,3.92v19.69a1.84,1.84,0,0,0,.68,1.63c.18.12.89.51,1.07.61a1.29,1.29,0,0,0,1.31-.11L231.68,288a4.93,4.93,0,0,0,2-3.92V264.38a1.84,1.84,0,0,0-.66-1.62C232.89,262.64,232.19,262.26,232,262.17Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,288,202.91,304.6c-1.13.65-2,0-2-1.56V283.36a4.92,4.92,0,0,1,2-3.92l28.77-16.61c1.13-.65,2,0,2,1.55v19.69A4.93,4.93,0,0,1,231.68,288Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,301.54c-.28.17-.51,0-.51-.38v-18.6a1.26,1.26,0,0,1,.51-1l27.18-15.69c.29-.16.52,0,.52.39v18.6a1.21,1.21,0,0,1-.52,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.32,292.69a.27.27,0,0,0,.35,0c.14-.09.26-.08.33,0a.91.91,0,0,1,.12.55v.23a1.27,1.27,0,0,1-.63,1.2l-2.25,1.3q-.63.36-.63-.48v-.22a1.27,1.27,0,0,1,.58-1.18,1.22,1.22,0,0,0,.58-1.16v-9.59c0-.55-.19-.71-.58-.48s-.58.05-.58-.52v-.23a1.25,1.25,0,0,1,.63-1.18l.37-.22a.68.68,0,0,1,.77,0l.5.37a1,1,0,0,1,.32.85v10.21A.91.91,0,0,0,211.32,292.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,280.42v-.23a1.24,1.24,0,0,1,.63-1.16l3.48-2a.71.71,0,0,1,.78-.08l.5.38a1,1,0,0,1,.32.84v12.12a1.28,1.28,0,0,1-.63,1.21l-.17.1c-.42.25-.63.08-.63-.49V279.62c0-.53-.21-.67-.63-.43l-3,1.74C212.17,281.18,212,281,212,280.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.83,274.28l3.21-1.86a.64.64,0,0,1,.77,0l.5.38a1,1,0,0,1,.32.84v10.82a2.35,2.35,0,0,1-.08.6,4.15,4.15,0,0,1-.25.61l-.51,1a2,2,0,0,1-.76.84l-3.21,1.85a.69.69,0,0,1-.77.05l-.5-.38a1,1,0,0,1-.32-.84V277.31a2.58,2.58,0,0,1,.32-1.21l.5-1A2.09,2.09,0,0,1,220.83,274.28Zm3.37,10.4v-9.61q0-.84-.63-.48l-2.28,1.32a1.29,1.29,0,0,0-.63,1.2v9.61q0,.81.63.45l2.28-1.32A1.24,1.24,0,0,0,224.2,284.68Z",
    style: {
      fill: "#407BFF"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.89,389.28c.9-10.66,0-15.14,1.14-31.79h0c.13-4.27.34-8.84.68-12.9,1.13-13.66,3.3-18.32,3.53-20.95,0,0-.72-23.89.54-53.79.59-14.07,4.73-18.29,8.1-25.72l41.31.46c2.19,18.62,2.06,53.17,1.71,72.16-.18,9.69-4.63,57.79-4.72,59-.33,4.22,0,5.9,1.67,7.69,3.44,3.76,8.46,7.36,12.79,10.66-.65,1.66-5.91,1.54-8.5.24a67,67,0,0,1-9.63-6.26c-3.56-2.69-8.77-4.87-8.78-8.9a4.27,4.27,0,0,0-.11-.72c0-2.35-4.59-33.39-5-41.44-.31-6.92.67-18.64.67-18.64l-3.69-23.84s-1.64,19.9-4.57,31.69c-2.39,9.59-6.6,22.26-9.31,34.07h0c-2.62,13.62-6.35,23.29-7,30.11-.21,1.63-2.26,17.61-3.07,21.27s-8.84,3.66-9.28-2.65C47.08,404.81,48.71,391.28,48.89,389.28Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,398.42a3.4,3.4,0,0,1-.65,3.47c-1.39,1.19-5.49,3.16-10.89,2.46S103.15,402,101,400.18s-5.19-4.34-7.64-4.88a16.14,16.14,0,0,1-5.8-2.89c-.73-.7-.62-3.81-.62-3.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,377.3s-.41,0-.55.73-.35,3.35-.7,4.75a20.24,20.24,0,0,0-.24,6.89c.29,1.59,4.34,3.37,6.7,4.27a29.93,29.93,0,0,1,7.66,4.82A22.38,22.38,0,0,0,112.8,403c5.37.08,8.86-1.37,9.94-3.29,1.33-2.38.29-3.76-5.89-6.61-1.17-.54-5.28-3-6.68-3.84a32,32,0,0,1-4.2-3.12,22,22,0,0,1-1.88-1.86,8.36,8.36,0,0,1-1.57-2c-.07-.16-.11-.35-.18-.52a8.76,8.76,0,0,1-.4-1.44c-.1-.51-.16-1.25-.65-1.56a4.14,4.14,0,0,0-2.21-.26,17.25,17.25,0,0,0-2.38.33c-.91.21-2,.29-2.5,1.14a4.37,4.37,0,0,0-.51,2.22c0,.36,0,.72,0,1.08,0,.16.07.43-.15.37s-.43-.6-.51-.78c-.17-.41-.28-.84-.47-1.23a5.86,5.86,0,0,0-.77-1.3,11,11,0,0,0-1.62-1c-.33-.26-.76-.39-1.06-.68A2.51,2.51,0,0,1,88.52,377.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,393.56c-7.79.53-10.25,5.31-10.58,8.27A18.39,18.39,0,0,0,112.8,403c5.37.08,9.08-1.37,10.16-3.29C124.21,397.46,123.36,395.65,117.85,393.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17,393.63a.43.43,0,0,1-.24-.08.39.39,0,0,1-.05-.54,9.17,9.17,0,0,1,7-2.75.38.38,0,1,1-.08.75,8.53,8.53,0,0,0-6.37,2.48A.41.41,0,0,1,106.17,393.63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,391.69a.38.38,0,0,1-.29-.62,9.16,9.16,0,0,1,7-2.76.38.38,0,0,1,.34.42.38.38,0,0,1-.42.33,8.49,8.49,0,0,0-6.37,2.49A.41.41,0,0,1,102.82,391.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.72,389.46a.35.35,0,0,1-.24-.08.37.37,0,0,1-.06-.53,9.21,9.21,0,0,1,7-2.76.36.36,0,0,1,.33.41.38.38,0,0,1-.42.34,8.51,8.51,0,0,0-6.37,2.49A.36.36,0,0,1,99.72,389.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,387.24a.35.35,0,0,1-.24-.08.37.37,0,0,1-.06-.53c1.49-1.87,4.86-3.11,7.69-2.8a.38.38,0,1,1-.08.75c-2.55-.27-5.69.86-7,2.52A.37.37,0,0,1,96.68,387.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,414.55c-.26,3.65-.86,6.06-2.18,8.19s-3.8,2.77-6.28,2.12-5.65-2.37-6.33-5.53a20,20,0,0,1-.46-8.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,388c-1,.07-1.39,5-2,9.88-.69,5.26-2.3,7.42-2.92,11.73-.7,4.92.09,7.13,1.79,10.13s7.82,6,10.9,1.76c2.51-3.45,2.66-7.31,2.49-12.24a108.34,108.34,0,0,1,.48-12.47c.24-3.69,1.11-7.41.22-7.83-.07.54-.15,1.23-.23,1.76a8.23,8.23,0,0,1-.35,2c-.11.27-.34.56-.43.11a3.15,3.15,0,0,1,0-.92c.17-1.36-.52-1.48-.89-1.59a44.38,44.38,0,0,0-4.75-.72c-.78-.06-3.49-.21-3.84.23a3,3,0,0,0-.36,1.42c-.1.74-.28,1.29-.3,1.05,0-.53.08-1.91.1-2.24s.07-.76.08-1.08S49,388.29,49,388Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.71,412.43A12.3,12.3,0,0,0,45.54,420c1.7,3,8.31,6,11.39,1.77,1.54-2.11,2-4.62,2.21-7.18C57.36,411.23,46.61,409.66,43.71,412.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,409.16l-.12,0a17.47,17.47,0,0,0-9.4-1,.39.39,0,0,1-.45-.29.38.38,0,0,1,.29-.45,17.94,17.94,0,0,1,9.9,1.07.39.39,0,0,1,.17.51A.41.41,0,0,1,57,409.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72,404.43a.35.35,0,0,1-.32-.26.37.37,0,0,1,.24-.47c4.62-1.5,9.69.88,9.88,1a.38.38,0,0,1,.16.52.4.4,0,0,1-.52.15s-5-2.33-9.28-.93A.45.45,0,0,1,47.72,404.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.92,401a.39.39,0,0,1-.32-.25.37.37,0,0,1,.24-.48,13.43,13.43,0,0,1,10.07,1,.37.37,0,0,1,.12.52.39.39,0,0,1-.52.12s-4.7-2.51-9.42-.89A.52.52,0,0,1,47.92,401Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.21,397.56a.38.38,0,0,1-.31-.25.37.37,0,0,1,.22-.48c4.76-1.71,10,.95,10.14,1.06a.38.38,0,0,1-.39.66s-5.07-2.6-9.49-1A.32.32,0,0,1,48.21,397.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.54,244.22c-4.71,8.32-4.92,15.14-5.68,40S52.15,318.7,52,321.7s-.67,8.34-2.39,23.1a152.39,152.39,0,0,0-.36,28.68s1,2.39,6.71,3c5.23.52,7.85-1.4,7.85-1.4S71,349.73,73.2,340.88c3.33-13.41,7.38-40.41,7.38-40.41l2.7,18.28s-1.7,8.13-.25,21.11,3.28,22.52,3.28,22.52a31.49,31.49,0,0,0,9,1.5,14,14,0,0,0,7.33-2s4.56-34.63,4.74-49.32-1-50.06-2.2-67.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.23,374.55a5.14,5.14,0,0,0,.77.51c-1.18-23.24,2.14-32.84,4.19-41.7.19-.85.38-1.66.55-2.44,1.54-6.93.3-18.57.42-30,0-3.44.06-7,.14-10.77.09-4.41.28-9,.7-13.5,8.15-.88,10-8.85,12.35-18.93.32-1.37.65-2.8,1-4.26l-.72-.17c-.36,1.46-.69,2.89-1,4.27-2.35,10.09-4.07,17.42-11.56,18.32,1-10.26,3.25-20.19,8.4-27.33l-.6-.43c-7.66,10.62-9,27.2-9.31,42-.08,3.77-.11,7.33-.15,10.77-.11,11.38,1.13,23-.39,29.84-.18.78-.36,1.58-.56,2.43C52.43,342,49.12,351.54,50.23,374.55Zm35.37-100-5,25.92,2.7,18.28.27-17.57,3.38-17.48c.1,1.74.2,3.53.3,5.35.85,15,1.37,26.56.54,30.14-2.28,9.79-1.72,16-.7,27.25.11,1.15.22,2.34.33,3.6.56,6.36,1.29,8.93,1.71,13l.77.19c-.43-4.09-1.17-6.79-1.74-13.29-.11-1.25-.22-2.45-.33-3.59-1-11.19-1.57-17.35.68-27,.86-3.67.38-14.53-.52-30.34-.16-2.87-.32-5.65-.46-8.3l.71-3.15c3.57-.81,9.31-3.45,10.41-8.33A18.71,18.71,0,0,1,85.6,274.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94,196.54c7.21,1.38,10.68,3.69,14.42,10.07s9.36,22.4,9.31,26h-15Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,226.86c3.2-.85,5.55-1.46,7.23-1.43-1.35-.88-7.34.15-7.34.15Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.62,196.07c5.11.41,8.82,1.82,12.23,6s3.69,5.78,5.5,10.34,3,7.59,3,7.59-3.42,6.14-14.56,5.22l-4-11.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-226",
    d: "M67.05,194.68s-6.46,1.7-12.9,4c0,0-7.08,2.86-3.21,23.64,1,5.24,3,12.86,3.5,19.34.31,3.68-.24,12.42-.73,20,0,0,11.76,7.69,32.8,5.34,16.51-1.84,19.6-9.34,19.6-9.34S105,239.32,103.66,227c-2-17.64-5.5-27.51-10-31l-9.4-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.71,178.21a33.91,33.91,0,0,0,4.2,9.08,4.08,4.08,0,0,0,2.42,1.84L69,182.74l-.35-4.45s3.46-3.35,3.68-6.56a12.5,12.5,0,0,0-.24-3.57l21.28.84s1.81-5.44-1.11-9.62c-2.79-4-6.83-6.5-13.94-5.93-8.69.7-13.08,5.11-13.6,8.72h0a6.24,6.24,0,0,0-3.18,3.24C60.75,167,60.24,170,62.71,178.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.62,184.24a3.85,3.85,0,0,0,.62.36,4.35,4.35,0,0,0,1.79.52,3.35,3.35,0,0,0,1.52-.51,4.94,4.94,0,0,0,1.4-1.09l-2.08,11.56c4.21,7.89,23.41,9.79,17,1.46l1.06-4.11a19.6,19.6,0,0,0,2.83-.36A7.59,7.59,0,0,0,94,186.38c1.15-4.73-.06-14.95-1-20.48a5.76,5.76,0,0,0-2.81-4c-3.53-1.65-6.68.95-11.48,3-2,.84-6.85,1.32-8.15.74a6.37,6.37,0,0,1,1.35,4,8.94,8.94,0,0,1-.53,3.12,14.54,14.54,0,0,0-1,2.7,2.11,2.11,0,0,1-.46,1.21,1.25,1.25,0,0,1-1.54-.05,7,7,0,0,1-1.11-1.25A3.8,3.8,0,0,0,65.5,174a3.48,3.48,0,0,0-3.69,1.43,5.75,5.75,0,0,0-.85,4A6.74,6.74,0,0,0,63.62,184.24Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,192.43a25.94,25.94,0,0,1-9.47-1.21c-2.27-.9-4.35-3.92-5.08-6.95.06,2.46,1.24,6.78,4.7,8.49s6.85,1.64,9.34,1.63Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.81,168.52,77,170.58a1.87,1.87,0,0,1,.41-2.53A1.7,1.7,0,0,1,79.81,168.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.13,170.15l-3.48-.54a1.68,1.68,0,0,1,1.94-1.51A1.87,1.87,0,0,1,92.13,170.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.39,173.66a1.42,1.42,0,1,0,1.27-1.57A1.43,1.43,0,0,0,78.39,173.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.94,172.63a1.42,1.42,0,1,0,1.27-1.58A1.42,1.42,0,0,0,88.94,172.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.28,171.37l1.35,9.08,5.07-2.11A21.52,21.52,0,0,0,84.28,171.37Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.28,183.69l0-.05a.33.33,0,0,0-.19-.08,13.67,13.67,0,0,1-1.62-.35,5.15,5.15,0,0,1-1.28-.65c-.37-.26-.62-.69-1-.89a.17.17,0,0,0-.25.12c0,.42.51.85.8,1.09a4,4,0,0,0,1.25.67,6,6,0,0,0,1.46.28,6.4,6.4,0,0,0,.76,0C85.24,183.84,85.32,183.77,85.28,183.69Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,246.56c.72,0,1.45,0,2.17,0a55.23,55.23,0,0,0,5.61-.16c1.17-.1,2.33-.25,3.48-.46a20.37,20.37,0,0,0,3.1-.67c2-.72,4-1.54,5.92-2.36a23.1,23.1,0,0,1,6.53-1.11c4.79-.4,9.06-.38,13.82-1.11a29.06,29.06,0,0,0,8.06-2.41,10.55,10.55,0,0,0,4.07-3.55c1.27-2,.59-3.32-1.19-4.56a23.28,23.28,0,0,0-12.27-3.35c-3,.79-6.56,2-9.9,3.07-3.15,1-5.53,1.88-8.74,2.68a11.87,11.87,0,0,1-4.22.12c-1.33-.18-2.48-.6-3.77-.81a30,30,0,0,0-5-.74c-2.86,0-5.78.91-7.71,1.18s-1.81,1.33-.35,2.13a5.07,5.07,0,0,0,2.41.35c.92,0,1.84-.07,2.76,0,.21,0,.63,0,.75.21s-.18.5-.38.59a8.33,8.33,0,0,1-3.65.37l-4,0c-.54,0-1.08,0-1.61,0a2.21,2.21,0,0,0-2,.87,1.19,1.19,0,0,0-.2.7c0,.21.12.38-.11.54a1.58,1.58,0,0,1-.61.16,1.49,1.49,0,0,0-1,.84,1.45,1.45,0,0,0,.1,1.33,2,2,0,0,0,.76.69,1.37,1.37,0,0,1,.42.29,2,2,0,0,1,.19.39,2.27,2.27,0,0,0,.66.9,4,4,0,0,0,1.86.73c.57.1,1.13.17,1.7.23.78.09,1.55.21,2.32.3.33.05.67.08,1,.12l.5.06a1.27,1.27,0,0,1,.48.07c-.1.09-.48.05-.62.06l-.72,0c-.46,0-.92.08-1.37.16a3.49,3.49,0,0,0-.9.28A1.17,1.17,0,0,0,62,246a.7.7,0,0,0,.52.35,4.28,4.28,0,0,0,.61.09C63.48,246.52,63.89,246.54,64.3,246.56Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06,239.42a29.25,29.25,0,0,0,2.84-6.84c-1-.21-1.92-.49-2.93-.66a30,30,0,0,0-5-.74c-2.86,0-5.78.91-7.71,1.18s-1.81,1.33-.35,2.13a5.07,5.07,0,0,0,2.41.35c.92,0,1.84-.07,2.76,0,.21,0,.63,0,.75.21s-.18.5-.38.59a8.33,8.33,0,0,1-3.65.37l-4,0c-.54,0-1.08,0-1.61,0a2.21,2.21,0,0,0-2,.87,1.19,1.19,0,0,0-.2.7c0,.18.08.33,0,.46a2.39,2.39,0,0,1,.73.72L60,240.93a12.12,12.12,0,0,1-3.24-.08l.37.25a1.56,1.56,0,0,1,.4.27,19.89,19.89,0,0,1,2.4.68,6.79,6.79,0,0,1,1.86,1.57l.17,0c.78.09,1.55.21,2.32.3.33.05.67.08,1,.12l.5.06a1.27,1.27,0,0,1,.48.07c-.1.09-.48.05-.62.06l-.72,0c-.46,0-.92.08-1.37.16a3.69,3.69,0,0,0-.65.18c2.27,1.75,5.43,2.58,8.08,1.38a8.38,8.38,0,0,0,1-.53C74.24,244.06,75.76,241.71,77.06,239.42Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.32,245.8c-2.66-.24-5.07-.45-8.93-6.65a98.06,98.06,0,0,1-7.51-14.67c-2.94-6.71-5.14-11.38-4.87-15.66.22-3.49,1.11-7.27,7.24-9.64,3.68,2.34,8.76,9,11.11,14.95s6.51,17.15,6.51,17.15Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.15,198.91c-6.38,2.61-8.7,7.44-6.94,14.61,2,8.06,7.39,18.75,7.39,18.75s3.61.18,8.14-2.76A17,17,0,0,0,69,222s-2.27-6.37-3.51-9.77C63,205.54,58.75,200,54.15,198.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,232.6c.18-7.23,3.47-11.62,6-17a81,81,0,0,0,4.82-11.93c.92-3.28,1.39-8,1-10.47A36.24,36.24,0,0,0,72,187.74c-.46-1.21,0-1.34,1.18-1.29s2.38.59,3.44,2.71,1.36,3.39,1.85,3.25,3-3,4.45-4.37,2-1.41,4.25-1.68a16.13,16.13,0,0,1,5.41.12,12.3,12.3,0,0,1,2.84,2c.77.6-.54,1.71-2,1.19L92,189.18c.57.44.53,1,.62,1.81a2.11,2.11,0,0,1-.44,1.41s.53.16.73,1.12a3.54,3.54,0,0,1-.07,1.73.84.84,0,0,1,.84.44c.32.54.75,1.4-1.17,3.16s-3.36,2.93-5,4.31a13,13,0,0,0-2.87,3c-1,1.47-1.32,4-2,8C81.26,223,81,225.2,79.46,230.62c-1.16,4.12-2.51,8.39-7,13-4,4.07-6.58,1.73-8.13-1.2A24,24,0,0,1,61.86,232.6Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,232.6c-.17-6.7,3.68-12.44,6.31-18.31a96.15,96.15,0,0,0,3.68-9,29,29,0,0,0,1.48-11.87,33.86,33.86,0,0,0-1.66-5.82c-.69-2,2.12-1.57,3.12-1,1.91,1.1,2.45,3.34,3.36,5.16.07.15.24.45.31.41,2-1.54,3.43-3.73,5.52-5.18a5.56,5.56,0,0,1,2.39-.68,22.31,22.31,0,0,1,4.9-.13c1.74,0,3,1.27,4.19,2.34-1.25-1-2.49-2.22-4.2-2.17a22.54,22.54,0,0,0-4.85.28,5.28,5.28,0,0,0-2.24.67c-2.08,1.49-3.46,3.75-5.51,5.33-.83.34-1.2-1.24-1.5-1.75-.65-1.38-1.26-3-2.64-3.78a3.6,3.6,0,0,0-2.16-.31c-.33.09-.17.37-.12.64,1,2.68,2,5.49,1.87,8.38,0,6.63-2.68,12.83-5.49,18.7S62,225.91,61.86,232.6Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2,190c1.7-.95,4-2.14,5.82-.8a4.37,4.37,0,0,0-2.88,0c-.87.24-2.07.57-2.94.76Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,193.62a6.84,6.84,0,0,1,4.42-1.22,32.53,32.53,0,0,1-4.42,1.22Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,197.16a26.93,26.93,0,0,1,3.84-1.91A6.06,6.06,0,0,1,89,197.16Z",
    style: {
      fill: "#af6152"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-226"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.81 446.15 101.8 436.89 148.03 410.2 148.03 419.46 101.81 446.15",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.81 446.15 101.8 436.89 148.03 410.2 148.03 419.46 101.81 446.15",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.81 436.89 61.56 413.66 61.56 422.91 101.81 446.15 101.81 436.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.81 436.89 61.56 413.66 61.56 422.91 101.81 446.15 101.81 436.89",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.8 436.89 61.56 413.66 107.8 386.96 148.03 410.2 101.8 436.89",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.8 436.89 61.56 413.66 107.8 386.96 148.03 410.2 101.8 436.89",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.8 433.08 141.43 410.2 145.9 290.89 101.8 316.35 101.8 433.08",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.8 433.08 141.43 410.2 145.9 290.89 101.8 316.35 101.8 433.08",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.8 433.08 68.16 413.66 63.69 294.34 101.8 316.35 101.8 433.08",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.8 433.08 68.16 413.66 63.69 294.34 101.8 316.35 101.8 433.08",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.37 304.85 145.9 290.89 101.8 316.35 63.69 294.34 64.22 308.31 101.8 330.01 145.37 304.85",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 325.64 98.71 312.85 160.63 277.1 160.63 289.89 98.71 325.64",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 325.64 98.71 312.85 160.63 277.1 160.63 289.89 98.71 325.64",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 312.85 55.36 287.83 55.36 300.62 98.71 325.64 98.71 312.85",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 312.85 55.36 287.83 55.36 300.62 98.71 325.64 98.71 312.85",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 312.85 55.36 287.83 117.28 252.08 160.63 277.1 98.71 312.85",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.71 312.85 55.36 287.83 117.28 252.08 160.63 277.1 98.71 312.85",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.59,287.2c0-1.26-.83-2.51-2.49-3.47a13.26,13.26,0,0,0-12,0c-1.66,1-2.49,2.21-2.49,3.47v1.66c0,1.26.83,2.52,2.49,3.48a13.32,13.32,0,0,0,12,0c1.66-1,2.49-2.22,2.49-3.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.08,283.73c-1.66,1-2.49,2.21-2.49,3.47s.83,2.51,2.49,3.47a13.26,13.26,0,0,0,12,0c1.66-1,2.49-2.22,2.49-3.47s-.83-2.51-2.49-3.47A13.26,13.26,0,0,0,70.08,283.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--sphere-12--inject-226",
    d: "M83.53,286.78a3.71,3.71,0,0,1-2.18,3,11.61,11.61,0,0,1-10.52,0,3.71,3.71,0,0,1-2.18-3,7.44,7.44,0,0,1,14.88,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,282.27a4.39,4.39,0,0,1,.14,2,6,6,0,0,1-3.29,4.19,11.35,11.35,0,0,1-5.37,1.05,9.49,9.49,0,0,1-2.71-.38,8.22,8.22,0,0,1-1.63-.8,4.91,4.91,0,0,0,1.7,1.52,11.61,11.61,0,0,0,10.52,0,3.71,3.71,0,0,0,2.18-3A7.38,7.38,0,0,0,82,282.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,280.88a5.16,5.16,0,0,0-2.71,3.26,2.54,2.54,0,0,0,.1,1.59,1.71,1.71,0,0,0,.63.65,3.42,3.42,0,0,0,3.44-.26c1-.62,1.88-1.53,2.87-2.23a8.86,8.86,0,0,1,2-1.06,2,2,0,0,0,.88-.46.73.73,0,0,0-.15-.95C78.15,279.8,75,279.91,73,280.88Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microphone--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.15,276a1.48,1.48,0,0,0-.88-1.22,4.68,4.68,0,0,0-4.22,0,1.48,1.48,0,0,0-.88,1.22v1.12a1.48,1.48,0,0,0,.88,1.22,4.68,4.68,0,0,0,4.22,0,1.48,1.48,0,0,0,.88-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.05,274.76a1.48,1.48,0,0,0-.88,1.22,1.46,1.46,0,0,0,.88,1.22,4.62,4.62,0,0,0,4.22,0,1.46,1.46,0,0,0,.88-1.22,1.48,1.48,0,0,0-.88-1.22A4.68,4.68,0,0,0,142.05,274.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,273.25a.89.89,0,0,0-.53-.73,2.78,2.78,0,0,0-2.54,0,.89.89,0,0,0-.53.73V276a.9.9,0,0,0,.53.73,2.78,2.78,0,0,0,2.54,0A.9.9,0,0,0,146,276Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89,272.52a.77.77,0,0,0,0,1.46,2.78,2.78,0,0,0,2.54,0,.77.77,0,0,0,0-1.46A2.78,2.78,0,0,0,142.89,272.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.57,273.06c0,.25-.82.25-.82,0,0-.42,0-.91,0-1.47.08-7.94.32-29-12.72-36l.39-.72c13.47,7.22,13.23,28.68,13.14,36.76C144.57,272.15,144.57,272.64,144.57,273.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,237.92l-4.12-2a2.76,2.76,0,0,1-1.28-3.7h0a2.76,2.76,0,0,1,3.7-1.28l4.13,2a2.77,2.77,0,0,1,1.27,3.7h0A2.78,2.78,0,0,1,129.63,237.92Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.44,315.65a1.3,1.3,0,0,0-1.36.09l-28.76,16.61a4.89,4.89,0,0,0-2,3.92V356a1.83,1.83,0,0,0,.68,1.64l1.06.61a1.31,1.31,0,0,0,1.32-.12l28.76-16.6a4.93,4.93,0,0,0,2-3.93V317.87a1.84,1.84,0,0,0-.66-1.62C140.3,316.13,139.6,315.75,139.44,315.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.44,315.65a1.3,1.3,0,0,0-1.36.09l-28.76,16.61a4.89,4.89,0,0,0-2,3.92V356a1.83,1.83,0,0,0,.68,1.64l1.06.61a1.31,1.31,0,0,0,1.32-.12l28.76-16.6a4.93,4.93,0,0,0,2-3.93V317.87a1.84,1.84,0,0,0-.66-1.62C140.3,316.13,139.6,315.75,139.44,315.65Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.09,341.48l-28.76,16.6c-1.14.66-2.06,0-2.06-1.55V336.85a4.9,4.9,0,0,1,2.06-3.92l28.76-16.61c1.13-.66,2,0,2,1.55v19.68A4.93,4.93,0,0,1,139.09,341.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,355c-.29.17-.52,0-.52-.39V336.05a1.24,1.24,0,0,1,.52-1l27.18-15.69c.28-.16.51,0,.51.39v18.6a1.23,1.23,0,0,1-.51,1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24,335.85l4.17-2.41a.63.63,0,0,1,.77,0l.5.38a1,1,0,0,1,.31.84v4.28a2.66,2.66,0,0,1-.31,1.22l-.5,1a2,2,0,0,1-.77.86l-2.74,1.59a1.27,1.27,0,0,0-.63,1.19v2.93c0,.55.21.71.63.47l3.7-2.13c.42-.24.62-.09.62.47v.23a1.26,1.26,0,0,1-.62,1.2l-4.18,2.41a1.07,1.07,0,0,1-.42.15.64.64,0,0,1-.35-.1l-.46-.26a1,1,0,0,1-.34-.85v-4.34a2,2,0,0,1,.08-.6,2.71,2.71,0,0,1,.25-.61l.48-.93a2,2,0,0,1,.77-.86l2.76-1.59a1.27,1.27,0,0,0,.62-1.2v-3.07c0-.56-.2-.72-.62-.48l-3.72,2.15c-.41.24-.62.08-.62-.48V337A1.28,1.28,0,0,1,114.24,335.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33,330.2l-3.72,2.14a1.24,1.24,0,0,0-.62,1.15v2.93c0,.56.21.71.62.47l2.74-1.58a.7.7,0,0,1,.79,0l.5.38a1,1,0,0,1,.31.85v4.36a2,2,0,0,1-.08.6,2.54,2.54,0,0,1-.25.61l-.5,1a2.07,2.07,0,0,1-.77.87l-4.16,2.4c-.42.24-.63.08-.63-.47v-.23a1.27,1.27,0,0,1,.63-1.2l3.71-2.14a1.28,1.28,0,0,0,.63-1.2V338q0-.84-.63-.48l-2.74,1.59a.68.68,0,0,1-.79,0l-.48-.35a.66.66,0,0,1-.25-.32,1.43,1.43,0,0,1-.08-.51v-4.22a2.35,2.35,0,0,1,.08-.6,2.71,2.71,0,0,1,.25-.61l.5-1a2.19,2.19,0,0,1,.77-.82l4.17-2.41c.41-.24.62-.09.62.44V329A1.34,1.34,0,0,1,127.33,330.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.12,326.1l3.21-1.85a.63.63,0,0,1,.77,0l.5.38a1,1,0,0,1,.31.84v10.82a2.35,2.35,0,0,1-.08.6,2.71,2.71,0,0,1-.25.61l-.5,1a2,2,0,0,1-.77.84l-3.21,1.85a.69.69,0,0,1-.77.05l-.5-.38a1,1,0,0,1-.31-.84V329.14a2.56,2.56,0,0,1,.31-1.21l.5-.95A2.13,2.13,0,0,1,131.12,326.1Zm3.37,10.41V326.9q0-.84-.63-.48l-2.29,1.32a1.27,1.27,0,0,0-.63,1.2v9.61q0,.81.63.45l2.29-1.32A1.24,1.24,0,0,0,134.49,336.51Z",
    style: {
      fill: "#407BFF"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.79,97.54a23,23,0,0,0-3.74,45.78l2.6,6.67a1.34,1.34,0,0,0,2.5,0l2.57-6.69a23,23,0,0,0-3.93-45.75Zm.06,44.28a21.24,21.24,0,1,1,21.23-21.24A21.23,21.23,0,0,1,415.85,141.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.84,
    cy: 120.58,
    r: 21.24,
    transform: "translate(202.94 497.6) rotate(-76.72)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.19,109.71a14.38,14.38,0,0,1,1.65-1.27,11.32,11.32,0,0,1,2-1,11.81,11.81,0,0,1,2.27-.7,12.84,12.84,0,0,1,2.64-.26,11.23,11.23,0,0,1,3.53.53A8.11,8.11,0,0,1,422,108.5a6.73,6.73,0,0,1,1.75,2.39,7.51,7.51,0,0,1,.63,3.13,8,8,0,0,1-.49,2.92,8.56,8.56,0,0,1-1.22,2.15,9.29,9.29,0,0,1-1.62,1.58l-1.65,1.25a12.61,12.61,0,0,0-1.35,1.16,2.3,2.3,0,0,0-.68,1.28l-.51,3.24h-3.75l-.38-3.62a3,3,0,0,1,.3-1.84,5.57,5.57,0,0,1,1.16-1.44,14.33,14.33,0,0,1,1.61-1.27,13.43,13.43,0,0,0,1.66-1.33,6.71,6.71,0,0,0,1.3-1.62,4.2,4.2,0,0,0,.53-2.15,3.3,3.3,0,0,0-.3-1.43,3.1,3.1,0,0,0-.84-1.09,3.52,3.52,0,0,0-1.28-.7,4.9,4.9,0,0,0-1.61-.25,7.31,7.31,0,0,0-2.14.28,8.16,8.16,0,0,0-1.49.62c-.41.23-.75.44-1,.63a1.43,1.43,0,0,1-.75.27,1.23,1.23,0,0,1-1.16-.66Zm4.2,23.75a3.4,3.4,0,0,1,.26-1.31,3.16,3.16,0,0,1,.7-1.07,3.46,3.46,0,0,1,1.06-.71,3.34,3.34,0,0,1,1.34-.27,3.25,3.25,0,0,1,1.32.27,3.77,3.77,0,0,1,1.07.71,3.36,3.36,0,0,1,.72,1.07,3.23,3.23,0,0,1,.26,1.31,3.18,3.18,0,0,1-.26,1.32,3.43,3.43,0,0,1-.72,1.06,3.36,3.36,0,0,1-1.07.7,3.41,3.41,0,0,1-1.32.26,3.52,3.52,0,0,1-1.34-.26,3.11,3.11,0,0,1-1.06-.7,3.21,3.21,0,0,1-.7-1.06A3.34,3.34,0,0,1,411.39,133.46Z",
    style: {
      fill: "#407BFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161,95.25c-4.09-6-15-10.88-28.52-11-12.29-.11-27.25,3.5-31,15.31C98.33,109.62,108.15,119,118.34,121a69.27,69.27,0,0,0,12.3,1.3c1.89,3.53,6.32,5.7,9.65,5.93a9.85,9.85,0,0,1-2.21-6.21,63.53,63.53,0,0,0,9.44-1.59C165.22,116,165.6,101.91,161,95.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,95.25c-4.09-6-15-10.88-28.52-11-12.29-.11-27.25,3.5-31,15.31C98.33,109.62,108.15,119,118.34,121a69.27,69.27,0,0,0,12.3,1.3c1.89,3.53,6.32,5.7,9.65,5.93a9.85,9.85,0,0,1-2.21-6.21,63.53,63.53,0,0,0,9.44-1.59C165.22,116,165.6,101.91,161,95.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,99.48a3.67,3.67,0,1,0,3.67,3.67A3.67,3.67,0,0,0,115,99.48Zm17.18,0a3.67,3.67,0,1,0,3.67,3.67A3.67,3.67,0,0,0,132.2,99.48Zm17.18,0a3.67,3.67,0,1,0,3.67,3.67A3.66,3.66,0,0,0,149.38,99.48Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqrms);
export default __webpack_public_path__ + "static/media/aqrms.664c6186b0ac206a72fcdcc74910f7f0.svg";
export { ForwardRef as ReactComponent };